import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _typeof from "@babel/runtime/helpers/typeof";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { keys.push.apply(keys, Object.getOwnPropertySymbols(object)); } if (enumerableOnly) keys = keys.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as React from "react";
import React__default, { useState, useRef, useLayoutEffect, useEffect, useReducer, useMemo, createElement, useCallback } from "react";
import { Sector, ResponsiveContainer, PieChart as PieChart$1, Pie, Cell, ComposedChart, CartesianGrid, XAxis, YAxis, Area, Line, Tooltip, BarChart, Bar } from "recharts";
import { useMotionValue, animate, motion, AnimatePresence } from "framer-motion";
import { Text as Text$1, forwardRef as forwardRef$1, Box as Box$2, Flex as Flex$1, Circle as Circle$1 } from "@chakra-ui/react";
import { ThemeContext } from "@emotion/react";
import _styled from "@emotion/styled";
import { jsx } from "react/jsx-runtime";
import { to, animated } from "@react-spring/web";
import { useTheme as useTheme$1 } from "@nivo/core";
import { useTooltip } from "@nivo/tooltip";
import ReactDOM from "react-dom";

var addIndexAction = function addIndexAction(indexLabel, index) {
  return {
    type: "addIndex",
    payload: {
      indexLabel: indexLabel,
      index: index
    }
  };
};

var removeIndexAction = function removeIndexAction(indexLabel) {
  return {
    type: "removeIndex",
    payload: {
      indexLabel: indexLabel
    }
  };
};

var activeIndexesReducer = function activeIndexesReducer(state2, action) {
  var type = action.type;

  switch (type) {
    case "addIndex":
      var payload = action.payload;
      state2[payload.indexLabel] = payload.index;
      return _objectSpread({}, state2);

    case "removeIndex":
      delete state2[action.payload.indexLabel];
      return _objectSpread({}, state2);

    default:
      return state2;
  }
};

var useAnimatableProperty = function useAnimatableProperty(from, to2, animationOptions) {
  var shouldAnimate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var motionValue = useMotionValue(from);

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var controls = useRef();
  useLayoutEffect(function () {
    return motionValue.onChange(function (newValue) {
      return setValue(function () {
        return newValue;
      });
    });
  });
  useEffect(function () {
    var _a, _b;

    if (shouldAnimate) {
      (_a = controls.current) == null ? void 0 : _a.stop();
      controls.current = animate(motionValue, to2, animationOptions);
    } else {
      (_b = controls.current) == null ? void 0 : _b.stop();
    }

    return function () {
      var _a2;

      return (_a2 = controls.current) == null ? void 0 : _a2.stop();
    };
  }, [shouldAnimate, to2]);
  return value;
};

var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};

function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}

var lodash_mergewith = {
  exports: {}
};
lodash_mergewith.exports;

(function (module, exports) {
  var LARGE_ARRAY_SIZE = 200;
  var HASH_UNDEFINED = "__lodash_hash_undefined__";
  var HOT_COUNT = 800,
      HOT_SPAN = 16;
  var MAX_SAFE_INTEGER = 9007199254740991;
  var argsTag = "[object Arguments]",
      arrayTag = "[object Array]",
      asyncTag = "[object AsyncFunction]",
      boolTag = "[object Boolean]",
      dateTag = "[object Date]",
      errorTag = "[object Error]",
      funcTag = "[object Function]",
      genTag = "[object GeneratorFunction]",
      mapTag = "[object Map]",
      numberTag = "[object Number]",
      nullTag = "[object Null]",
      objectTag = "[object Object]",
      proxyTag = "[object Proxy]",
      regexpTag = "[object RegExp]",
      setTag = "[object Set]",
      stringTag = "[object String]",
      undefinedTag = "[object Undefined]",
      weakMapTag = "[object WeakMap]";
  var arrayBufferTag = "[object ArrayBuffer]",
      dataViewTag = "[object DataView]",
      float32Tag = "[object Float32Array]",
      float64Tag = "[object Float64Array]",
      int8Tag = "[object Int8Array]",
      int16Tag = "[object Int16Array]",
      int32Tag = "[object Int32Array]",
      uint8Tag = "[object Uint8Array]",
      uint8ClampedTag = "[object Uint8ClampedArray]",
      uint16Tag = "[object Uint16Array]",
      uint32Tag = "[object Uint32Array]";
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
  var reIsHostCtor = /^\[object .+?Constructor\]$/;
  var reIsUint = /^(?:0|[1-9]\d*)$/;
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
  var freeGlobal = _typeof(commonjsGlobal) == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
  var freeSelf = (typeof self === "undefined" ? "undefined" : _typeof(self)) == "object" && self && self.Object === Object && self;
  var root = freeGlobal || freeSelf || Function("return this")();
  var freeExports = exports && !exports.nodeType && exports;
  var freeModule = freeExports && true && module && !module.nodeType && module;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  var freeProcess = moduleExports && freeGlobal.process;

  var nodeUtil = function () {
    try {
      var types = freeModule && freeModule.require && freeModule.require("util").types;

      if (types) {
        return types;
      }

      return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
  }();

  var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0:
        return func.call(thisArg);

      case 1:
        return func.call(thisArg, args[0]);

      case 2:
        return func.call(thisArg, args[0], args[1]);

      case 3:
        return func.call(thisArg, args[0], args[1], args[2]);
    }

    return func.apply(thisArg, args);
  }

  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }

    return result;
  }

  function baseUnary(func) {
    return function (value) {
      return func(value);
    };
  }

  function getValue(object, key) {
    return object == null ? void 0 : object[key];
  }

  function overArg(func, transform10) {
    return function (arg) {
      return func(transform10(arg));
    };
  }

  var arrayProto = Array.prototype,
      funcProto = Function.prototype,
      objectProto = Object.prototype;
  var coreJsData = root["__core-js_shared__"];
  var funcToString = funcProto.toString;
  var hasOwnProperty = objectProto.hasOwnProperty;

  var maskSrcKey = function () {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
  }();

  var nativeObjectToString = objectProto.toString;
  var objectCtorString = funcToString.call(Object);
  var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
  var Buffer = moduleExports ? root.Buffer : void 0,
      Symbol2 = root.Symbol,
      Uint8Array = root.Uint8Array,
      allocUnsafe = Buffer ? Buffer.allocUnsafe : void 0,
      getPrototype = overArg(Object.getPrototypeOf, Object),
      objectCreate = Object.create,
      propertyIsEnumerable = objectProto.propertyIsEnumerable,
      splice = arrayProto.splice,
      symToStringTag = Symbol2 ? Symbol2.toStringTag : void 0;

  var defineProperty = function () {
    try {
      var func = getNative(Object, "defineProperty");
      func({}, "", {});
      return func;
    } catch (e) {}
  }();

  var nativeIsBuffer = Buffer ? Buffer.isBuffer : void 0,
      nativeMax = Math.max,
      nativeNow = Date.now;
  var Map2 = getNative(root, "Map"),
      nativeCreate = getNative(Object, "create");

  var baseCreate = function () {
    function object() {}

    return function (proto) {
      if (!isObject2(proto)) {
        return {};
      }

      if (objectCreate) {
        return objectCreate(proto);
      }

      object.prototype = proto;
      var result = new object();
      object.prototype = void 0;
      return result;
    };
  }();

  function Hash(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;
    this.clear();

    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }

  function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
  }

  function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
  }

  function hashGet(key) {
    var data = this.__data__;

    if (nativeCreate) {
      var result = data[key];
      return result === HASH_UNDEFINED ? void 0 : result;
    }

    return hasOwnProperty.call(data, key) ? data[key] : void 0;
  }

  function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== void 0 : hasOwnProperty.call(data, key);
  }

  function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === void 0 ? HASH_UNDEFINED : value;
    return this;
  }

  Hash.prototype.clear = hashClear;
  Hash.prototype["delete"] = hashDelete;
  Hash.prototype.get = hashGet;
  Hash.prototype.has = hashHas;
  Hash.prototype.set = hashSet;

  function ListCache(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;
    this.clear();

    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }

  function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
  }

  function listCacheDelete(key) {
    var data = this.__data__,
        index = assocIndexOf(data, key);

    if (index < 0) {
      return false;
    }

    var lastIndex = data.length - 1;

    if (index == lastIndex) {
      data.pop();
    } else {
      splice.call(data, index, 1);
    }

    --this.size;
    return true;
  }

  function listCacheGet(key) {
    var data = this.__data__,
        index = assocIndexOf(data, key);
    return index < 0 ? void 0 : data[index][1];
  }

  function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
  }

  function listCacheSet(key, value) {
    var data = this.__data__,
        index = assocIndexOf(data, key);

    if (index < 0) {
      ++this.size;
      data.push([key, value]);
    } else {
      data[index][1] = value;
    }

    return this;
  }

  ListCache.prototype.clear = listCacheClear;
  ListCache.prototype["delete"] = listCacheDelete;
  ListCache.prototype.get = listCacheGet;
  ListCache.prototype.has = listCacheHas;
  ListCache.prototype.set = listCacheSet;

  function MapCache(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;
    this.clear();

    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }

  function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
      "hash": new Hash(),
      "map": new (Map2 || ListCache)(),
      "string": new Hash()
    };
  }

  function mapCacheDelete(key) {
    var result = getMapData(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
  }

  function mapCacheGet(key) {
    return getMapData(this, key).get(key);
  }

  function mapCacheHas(key) {
    return getMapData(this, key).has(key);
  }

  function mapCacheSet(key, value) {
    var data = getMapData(this, key),
        size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
  }

  MapCache.prototype.clear = mapCacheClear;
  MapCache.prototype["delete"] = mapCacheDelete;
  MapCache.prototype.get = mapCacheGet;
  MapCache.prototype.has = mapCacheHas;
  MapCache.prototype.set = mapCacheSet;

  function Stack2(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
  }

  function stackClear() {
    this.__data__ = new ListCache();
    this.size = 0;
  }

  function stackDelete(key) {
    var data = this.__data__,
        result = data["delete"](key);
    this.size = data.size;
    return result;
  }

  function stackGet(key) {
    return this.__data__.get(key);
  }

  function stackHas(key) {
    return this.__data__.has(key);
  }

  function stackSet(key, value) {
    var data = this.__data__;

    if (data instanceof ListCache) {
      var pairs = data.__data__;

      if (!Map2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
        pairs.push([key, value]);
        this.size = ++data.size;
        return this;
      }

      data = this.__data__ = new MapCache(pairs);
    }

    data.set(key, value);
    this.size = data.size;
    return this;
  }

  Stack2.prototype.clear = stackClear;
  Stack2.prototype["delete"] = stackDelete;
  Stack2.prototype.get = stackGet;
  Stack2.prototype.has = stackHas;
  Stack2.prototype.set = stackSet;

  function arrayLikeKeys(value, inherited) {
    var isArr = isArray2(value),
        isArg = !isArr && isArguments(value),
        isBuff = !isArr && !isArg && isBuffer(value),
        isType = !isArr && !isArg && !isBuff && isTypedArray(value),
        skipIndexes = isArr || isArg || isBuff || isType,
        result = skipIndexes ? baseTimes(value.length, String) : [],
        length = result.length;

    for (var key in value) {
      if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && ( // Safari 9 has enumerable `arguments.length` in strict mode.
      key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
      isIndex(key, length)))) {
        result.push(key);
      }
    }

    return result;
  }

  function assignMergeValue(object, key, value) {
    if (value !== void 0 && !eq(object[key], value) || value === void 0 && !(key in object)) {
      baseAssignValue(object, key, value);
    }
  }

  function assignValue(object, key, value) {
    var objValue = object[key];

    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === void 0 && !(key in object)) {
      baseAssignValue(object, key, value);
    }
  }

  function assocIndexOf(array, key) {
    var length = array.length;

    while (length--) {
      if (eq(array[length][0], key)) {
        return length;
      }
    }

    return -1;
  }

  function baseAssignValue(object, key, value) {
    if (key == "__proto__" && defineProperty) {
      defineProperty(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
      });
    } else {
      object[key] = value;
    }
  }

  var baseFor = createBaseFor();

  function baseGetTag(value) {
    if (value == null) {
      return value === void 0 ? undefinedTag : nullTag;
    }

    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
  }

  function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
  }

  function baseIsNative(value) {
    if (!isObject2(value) || isMasked(value)) {
      return false;
    }

    var pattern = isFunction2(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
  }

  function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
  }

  function baseKeysIn(object) {
    if (!isObject2(object)) {
      return nativeKeysIn(object);
    }

    var isProto = isPrototype(object),
        result = [];

    for (var key in object) {
      if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) {
        result.push(key);
      }
    }

    return result;
  }

  function baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) {
      return;
    }

    baseFor(source, function (srcValue, key) {
      stack || (stack = new Stack2());

      if (isObject2(srcValue)) {
        baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
      } else {
        var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : void 0;

        if (newValue === void 0) {
          newValue = srcValue;
        }

        assignMergeValue(object, key, newValue);
      }
    }, keysIn);
  }

  function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = safeGet(object, key),
        srcValue = safeGet(source, key),
        stacked = stack.get(srcValue);

    if (stacked) {
      assignMergeValue(object, key, stacked);
      return;
    }

    var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : void 0;
    var isCommon = newValue === void 0;

    if (isCommon) {
      var isArr = isArray2(srcValue),
          isBuff = !isArr && isBuffer(srcValue),
          isTyped = !isArr && !isBuff && isTypedArray(srcValue);
      newValue = srcValue;

      if (isArr || isBuff || isTyped) {
        if (isArray2(objValue)) {
          newValue = objValue;
        } else if (isArrayLikeObject(objValue)) {
          newValue = copyArray(objValue);
        } else if (isBuff) {
          isCommon = false;
          newValue = cloneBuffer(srcValue, true);
        } else if (isTyped) {
          isCommon = false;
          newValue = cloneTypedArray(srcValue, true);
        } else {
          newValue = [];
        }
      } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
        newValue = objValue;

        if (isArguments(objValue)) {
          newValue = toPlainObject(objValue);
        } else if (!isObject2(objValue) || isFunction2(objValue)) {
          newValue = initCloneObject(srcValue);
        }
      } else {
        isCommon = false;
      }
    }

    if (isCommon) {
      stack.set(srcValue, newValue);
      mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
      stack["delete"](srcValue);
    }

    assignMergeValue(object, key, newValue);
  }

  function baseRest(func, start) {
    return setToString(overRest(func, start, identity), func + "");
  }

  var baseSetToString = !defineProperty ? identity : function (func, string) {
    return defineProperty(func, "toString", {
      "configurable": true,
      "enumerable": false,
      "value": constant(string),
      "writable": true
    });
  };

  function cloneBuffer(buffer, isDeep) {
    if (isDeep) {
      return buffer.slice();
    }

    var length = buffer.length,
        result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
  }

  function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
  }

  function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
  }

  function copyArray(source, array) {
    var index = -1,
        length = source.length;
    array || (array = Array(length));

    while (++index < length) {
      array[index] = source[index];
    }

    return array;
  }

  function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1,
        length = props.length;

    while (++index < length) {
      var key = props[index];
      var newValue = customizer ? customizer(object[key], source[key], key, object, source) : void 0;

      if (newValue === void 0) {
        newValue = source[key];
      }

      if (isNew) {
        baseAssignValue(object, key, newValue);
      } else {
        assignValue(object, key, newValue);
      }
    }

    return object;
  }

  function createAssigner(assigner) {
    return baseRest(function (object, sources) {
      var index = -1,
          length = sources.length,
          customizer = length > 1 ? sources[length - 1] : void 0,
          guard = length > 2 ? sources[2] : void 0;
      customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : void 0;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        customizer = length < 3 ? void 0 : customizer;
        length = 1;
      }

      object = Object(object);

      while (++index < length) {
        var source = sources[index];

        if (source) {
          assigner(object, source, index, customizer);
        }
      }

      return object;
    });
  }

  function createBaseFor(fromRight) {
    return function (object, iteratee, keysFunc) {
      var index = -1,
          iterable = Object(object),
          props = keysFunc(object),
          length = props.length;

      while (length--) {
        var key = props[fromRight ? length : ++index];

        if (iteratee(iterable[key], key, iterable) === false) {
          break;
        }
      }

      return object;
    };
  }

  function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
  }

  function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : void 0;
  }

  function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag),
        tag = value[symToStringTag];

    try {
      value[symToStringTag] = void 0;
      var unmasked = true;
    } catch (e) {}

    var result = nativeObjectToString.call(value);

    if (unmasked) {
      if (isOwn) {
        value[symToStringTag] = tag;
      } else {
        delete value[symToStringTag];
      }
    }

    return result;
  }

  function initCloneObject(object) {
    return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
  }

  function isIndex(value, length) {
    var type = _typeof(value);

    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
  }

  function isIterateeCall(value, index, object) {
    if (!isObject2(object)) {
      return false;
    }

    var type = _typeof(index);

    if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) {
      return eq(object[index], value);
    }

    return false;
  }

  function isKeyable(value) {
    var type = _typeof(value);

    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
  }

  function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
  }

  function isPrototype(value) {
    var Ctor = value && value.constructor,
        proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
  }

  function nativeKeysIn(object) {
    var result = [];

    if (object != null) {
      for (var key in Object(object)) {
        result.push(key);
      }
    }

    return result;
  }

  function objectToString(value) {
    return nativeObjectToString.call(value);
  }

  function overRest(func, start, transform10) {
    start = nativeMax(start === void 0 ? func.length - 1 : start, 0);
    return function () {
      var args = arguments,
          index = -1,
          length = nativeMax(args.length - start, 0),
          array = Array(length);

      while (++index < length) {
        array[index] = args[start + index];
      }

      index = -1;
      var otherArgs = Array(start + 1);

      while (++index < start) {
        otherArgs[index] = args[index];
      }

      otherArgs[start] = transform10(array);
      return apply(func, this, otherArgs);
    };
  }

  function safeGet(object, key) {
    if (key === "constructor" && typeof object[key] === "function") {
      return;
    }

    if (key == "__proto__") {
      return;
    }

    return object[key];
  }

  var setToString = shortOut(baseSetToString);

  function shortOut(func) {
    var count = 0,
        lastCalled = 0;
    return function () {
      var stamp = nativeNow(),
          remaining = HOT_SPAN - (stamp - lastCalled);
      lastCalled = stamp;

      if (remaining > 0) {
        if (++count >= HOT_COUNT) {
          return arguments[0];
        }
      } else {
        count = 0;
      }

      return func.apply(void 0, arguments);
    };
  }

  function toSource(func) {
    if (func != null) {
      try {
        return funcToString.call(func);
      } catch (e) {}

      try {
        return func + "";
      } catch (e) {}
    }

    return "";
  }

  function eq(value, other) {
    return value === other || value !== value && other !== other;
  }

  var isArguments = baseIsArguments(function () {
    return arguments;
  }()) ? baseIsArguments : function (value) {
    return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
  };
  var isArray2 = Array.isArray;

  function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction2(value);
  }

  function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
  }

  var isBuffer = nativeIsBuffer || stubFalse;

  function isFunction2(value) {
    if (!isObject2(value)) {
      return false;
    }

    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
  }

  function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
  }

  function isObject2(value) {
    var type = _typeof(value);

    return value != null && (type == "object" || type == "function");
  }

  function isObjectLike(value) {
    return value != null && _typeof(value) == "object";
  }

  function isPlainObject(value) {
    if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
      return false;
    }

    var proto = getPrototype(value);

    if (proto === null) {
      return true;
    }

    var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
  }

  var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

  function toPlainObject(value) {
    return copyObject(value, keysIn(value));
  }

  function keysIn(object) {
    return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
  }

  var mergeWith2 = createAssigner(function (object, source, srcIndex, customizer) {
    baseMerge(object, source, srcIndex, customizer);
  });

  function constant(value) {
    return function () {
      return value;
    };
  }

  function identity(value) {
    return value;
  }

  function stubFalse() {
    return false;
  }

  module.exports = mergeWith2;
})(lodash_mergewith, lodash_mergewith.exports);

var lodash_mergewithExports = lodash_mergewith.exports;
var mergeWith =
/* @__PURE__ */
getDefaultExportFromCjs(lodash_mergewithExports);

function isNumber(value) {
  return typeof value === "number";
}

function isArray(value) {
  return Array.isArray(value);
}

function isFunction(value) {
  return typeof value === "function";
}

function isObject(value) {
  var type = _typeof(value);

  return value != null && (type === "object" || type === "function") && !isArray(value);
}

function isNull(value) {
  return value == null;
}

function isString(value) {
  return Object.prototype.toString.call(value) === "[object String]";
}

function isCssVar(value) {
  return /^var\(--.+\)$/.test(value);
}

var __DEV__ = process.env.NODE_ENV !== "production";

process.env.NODE_ENV === "test";

function omit(object, keys) {
  var result = {};
  Object.keys(object).forEach(function (key) {
    if (keys.includes(key)) return;
    result[key] = object[key];
  });
  return result;
}

function get(obj, path, fallback, index) {
  var key = typeof path === "string" ? path.split(".") : [path];

  for (index = 0; index < key.length; index += 1) {
    if (!obj) break;
    obj = obj[key[index]];
  }

  return obj === void 0 ? fallback : obj;
}

var memoize = function memoize2(fn) {
  var cache =
  /* @__PURE__ */
  new WeakMap();

  var memoizedFn = function memoizedFn2(obj, path, fallback, index) {
    if (typeof obj === "undefined") {
      return fn(obj, path, fallback);
    }

    if (!cache.has(obj)) {
      cache.set(obj,
      /* @__PURE__ */
      new Map());
    }

    var map = cache.get(obj);

    if (map.has(path)) {
      return map.get(path);
    }

    var value = fn(obj, path, fallback, index);
    map.set(path, value);
    return value;
  };

  return memoizedFn;
};

var memoizedGet = memoize(get);

function objectFilter(object, fn) {
  var result = {};
  Object.keys(object).forEach(function (key) {
    var value = object[key];
    var shouldPass = fn(value, key, object);

    if (shouldPass) {
      result[key] = value;
    }
  });
  return result;
}

var filterUndefined = function filterUndefined2(object) {
  return objectFilter(object, function (val) {
    return val !== null && val !== void 0;
  });
};

var objectKeys = function objectKeys2(obj) {
  return Object.keys(obj);
};

var cx = function cx2() {
  for (var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++) {
    classNames[_key] = arguments[_key];
  }

  return classNames.filter(Boolean).join(" ");
};

function runIfFn(valueOrFn) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return isFunction(valueOrFn) ? valueOrFn.apply(void 0, args) : valueOrFn;
}

function mapResponsive(prop2, mapper) {
  if (isArray(prop2)) {
    return prop2.map(function (item) {
      if (item === null) {
        return null;
      }

      return mapper(item);
    });
  }

  if (isObject(prop2)) {
    return objectKeys(prop2).reduce(function (result, key) {
      result[key] = mapper(prop2[key]);
      return result;
    }, {});
  }

  if (prop2 != null) {
    return mapper(prop2);
  }

  return null;
}

var ColorModeContext =
/* @__PURE__ */
React.createContext({});

if (__DEV__) {
  ColorModeContext.displayName = "ColorModeContext";
}

var useColorMode = function useColorMode2() {
  var context = React.useContext(ColorModeContext);

  if (context === void 0) {
    throw new Error("useColorMode must be used within a ColorModeProvider");
  }

  return context;
};

function _extends$3() {
  _extends$3 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$3.apply(this, arguments);
}

var tokenToCSSVar = function tokenToCSSVar2(scale, value) {
  return function (theme) {
    var valueStr = String(value);
    var key = scale ? scale + "." + valueStr : valueStr;
    return isObject(theme.__cssMap) && key in theme.__cssMap ? theme.__cssMap[key].varRef : value;
  };
};

function createTransform(options) {
  var scale = options.scale,
      transform10 = options.transform,
      compose = options.compose;

  var fn = function fn2(value, theme) {
    var _transform;

    var _value = tokenToCSSVar(scale, value)(theme);

    var result = (_transform = transform10 == null ? void 0 : transform10(_value, theme)) != null ? _transform : _value;

    if (compose) {
      result = compose(result, theme);
    }

    return result;
  };

  return fn;
}

function toConfig(scale, transform10) {
  return function (property) {
    var result = {
      property: property,
      scale: scale
    };
    result.transform = createTransform({
      scale: scale,
      transform: transform10
    });
    return result;
  };
}

var getRtl = function getRtl2(_ref) {
  var rtl = _ref.rtl,
      ltr = _ref.ltr;
  return function (theme) {
    return theme.direction === "rtl" ? rtl : ltr;
  };
};

function logical(options) {
  var property = options.property,
      scale = options.scale,
      transform10 = options.transform;
  return {
    scale: scale,
    property: getRtl(property),
    transform: scale ? createTransform({
      scale: scale,
      compose: transform10
    }) : transform10
  };
}

var _spaceXTemplate, _spaceYTemplate;

var transformTemplate = ["rotate(var(--chakra-rotate, 0))", "scaleX(var(--chakra-scale-x, 1))", "scaleY(var(--chakra-scale-y, 1))", "skewX(var(--chakra-skew-x, 0))", "skewY(var(--chakra-skew-y, 0))"];

function getTransformTemplate() {
  return ["translateX(var(--chakra-translate-x, 0))", "translateY(var(--chakra-translate-y, 0))"].concat(transformTemplate).join(" ");
}

function getTransformGpuTemplate() {
  return ["translate3d(var(--chakra-translate-x, 0), var(--chakra-translate-y, 0), 0)"].concat(transformTemplate).join(" ");
}

var filterTemplate = {
  "--chakra-blur": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-invert": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-sepia": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-drop-shadow": "var(--chakra-empty,/*!*/ /*!*/)",
  filter: ["var(--chakra-blur)", "var(--chakra-brightness)", "var(--chakra-contrast)", "var(--chakra-grayscale)", "var(--chakra-hue-rotate)", "var(--chakra-invert)", "var(--chakra-saturate)", "var(--chakra-sepia)", "var(--chakra-drop-shadow)"].join(" ")
};
var backdropFilterTemplate = {
  backdropFilter: ["var(--chakra-backdrop-blur)", "var(--chakra-backdrop-brightness)", "var(--chakra-backdrop-contrast)", "var(--chakra-backdrop-grayscale)", "var(--chakra-backdrop-hue-rotate)", "var(--chakra-backdrop-invert)", "var(--chakra-backdrop-opacity)", "var(--chakra-backdrop-saturate)", "var(--chakra-backdrop-sepia)"].join(" "),
  "--chakra-backdrop-blur": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-invert": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-opacity": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-sepia": "var(--chakra-empty,/*!*/ /*!*/)"
};

function getRingTemplate(value) {
  return {
    "--chakra-ring-offset-shadow": "var(--chakra-ring-inset) 0 0 0 var(--chakra-ring-offset-width) var(--chakra-ring-offset-color)",
    "--chakra-ring-shadow": "var(--chakra-ring-inset) 0 0 0 calc(var(--chakra-ring-width) + var(--chakra-ring-offset-width)) var(--chakra-ring-color)",
    "--chakra-ring-width": value,
    boxShadow: ["var(--chakra-ring-offset-shadow)", "var(--chakra-ring-shadow)", "var(--chakra-shadow, 0 0 #0000)"].join(", ")
  };
}

var flexDirectionTemplate = {
  "row-reverse": {
    space: "--chakra-space-x-reverse",
    divide: "--chakra-divide-x-reverse"
  },
  "column-reverse": {
    space: "--chakra-space-y-reverse",
    divide: "--chakra-divide-y-reverse"
  }
};
var owlSelector = "& > :not(style) ~ :not(style)";
var spaceXTemplate = (_spaceXTemplate = {}, _spaceXTemplate[owlSelector] = {
  marginInlineStart: "calc(var(--chakra-space-x) * calc(1 - var(--chakra-space-x-reverse)))",
  marginInlineEnd: "calc(var(--chakra-space-x) * var(--chakra-space-x-reverse))"
}, _spaceXTemplate);
var spaceYTemplate = (_spaceYTemplate = {}, _spaceYTemplate[owlSelector] = {
  marginTop: "calc(var(--chakra-space-y) * calc(1 - var(--chakra-space-y-reverse)))",
  marginBottom: "calc(var(--chakra-space-y) * var(--chakra-space-y-reverse))"
}, _spaceYTemplate);

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };

  return _setPrototypeOf(o, p);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _wrapRegExp() {
  _wrapRegExp = function _wrapRegExp(re, groups) {
    return new BabelRegExp(re, void 0, groups);
  };

  var _super = RegExp.prototype;

  var _groups =
  /* @__PURE__ */
  new WeakMap();

  function BabelRegExp(re, flags, groups) {
    var _this = new RegExp(re, flags);

    _groups.set(_this, groups || _groups.get(re));

    return _setPrototypeOf(_this, BabelRegExp.prototype);
  }

  _inherits(BabelRegExp, RegExp);

  BabelRegExp.prototype.exec = function (str) {
    var result = _super.exec.call(this, str);

    if (result) result.groups = buildGroups(result, this);
    return result;
  };

  BabelRegExp.prototype[Symbol.replace] = function (str, substitution) {
    if (typeof substitution === "string") {
      var groups = _groups.get(this);

      return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) {
        return "$" + groups[name];
      }));
    } else if (typeof substitution === "function") {
      var _this = this;

      return _super[Symbol.replace].call(this, str, function () {
        var args = arguments;

        if (_typeof(args[args.length - 1]) !== "object") {
          args = [].slice.call(args);
          args.push(buildGroups(args, _this));
        }

        return substitution.apply(this, args);
      });
    } else {
      return _super[Symbol.replace].call(this, str, substitution);
    }
  };

  function buildGroups(result, re) {
    var g = _groups.get(re);

    return Object.keys(g).reduce(function (groups, name) {
      groups[name] = result[g[name]];
      return groups;
    },
    /* @__PURE__ */
    Object.create(null));
  }

  return _wrapRegExp.apply(this, arguments);
}

var directionMap = {
  "to-t": "to top",
  "to-tr": "to top right",
  "to-r": "to right",
  "to-br": "to bottom right",
  "to-b": "to bottom",
  "to-bl": "to bottom left",
  "to-l": "to left",
  "to-tl": "to top left"
};
var valueSet = new Set(Object.values(directionMap));
var globalSet =
/* @__PURE__ */
new Set(["none", "-moz-initial", "inherit", "initial", "revert", "unset"]);

var trimSpace = function trimSpace2(str) {
  return str.trim();
};

function parseGradient(value, theme) {
  var _regex$exec$groups, _regex$exec;

  if (value == null || globalSet.has(value)) return value;

  var regex =
  /* @__PURE__ */
  _wrapRegExp(/(^[\x2DA-Za-z]+)\(((.*))\)/g, {
    type: 1,
    values: 2
  });

  var _ref = (_regex$exec$groups = (_regex$exec = regex.exec(value)) == null ? void 0 : _regex$exec.groups) != null ? _regex$exec$groups : {},
      type = _ref.type,
      values = _ref.values;

  if (!type || !values) return value;

  var _type = type.includes("-gradient") ? type : type + "-gradient";

  var _values$split$map$fil = values.split(",").map(trimSpace).filter(Boolean),
      maybeDirection = _values$split$map$fil[0],
      stops = _values$split$map$fil.slice(1);

  if ((stops == null ? void 0 : stops.length) === 0) return value;
  var direction = maybeDirection in directionMap ? directionMap[maybeDirection] : maybeDirection;
  stops.unshift(direction);

  var _values = stops.map(function (stop) {
    if (valueSet.has(stop)) return stop;
    var firstStop = stop.indexOf(" ");

    var _ref2 = firstStop !== -1 ? [stop.substr(0, firstStop), stop.substr(firstStop + 1)] : [stop],
        _color = _ref2[0],
        _stop = _ref2[1];

    var _stopOrFunc = isCSSFunction(_stop) ? _stop : _stop && _stop.split(" ");

    var key = "colors." + _color;
    var color2 = key in theme.__cssMap ? theme.__cssMap[key].varRef : _color;
    return _stopOrFunc ? [color2].concat(Array.isArray(_stopOrFunc) ? _stopOrFunc : [_stopOrFunc]).join(" ") : color2;
  });

  return _type + "(" + _values.join(", ") + ")";
}

var isCSSFunction = function isCSSFunction2(value) {
  return isString(value) && value.includes("(") && value.includes(")");
};

var gradientTransform = function gradientTransform2(value, theme) {
  return parseGradient(value, theme != null ? theme : {});
};

var analyzeCSSValue = function analyzeCSSValue2(value) {
  var num = parseFloat(value.toString());
  var unit = value.toString().replace(String(num), "");
  return {
    unitless: !unit,
    value: num,
    unit: unit
  };
};

var wrap = function wrap2(str) {
  return function (value) {
    return str + "(" + value + ")";
  };
};

var transformFunctions = {
  filter: function filter(value) {
    return value !== "auto" ? value : filterTemplate;
  },
  backdropFilter: function backdropFilter(value) {
    return value !== "auto" ? value : backdropFilterTemplate;
  },
  ring: function ring(value) {
    return getRingTemplate(transformFunctions.px(value));
  },
  bgClip: function bgClip(value) {
    return value === "text" ? {
      color: "transparent",
      backgroundClip: "text"
    } : {
      backgroundClip: value
    };
  },
  transform: function transform(value) {
    if (value === "auto") return getTransformTemplate();
    if (value === "auto-gpu") return getTransformGpuTemplate();
    return value;
  },
  px: function px(value) {
    if (value == null) return value;

    var _analyzeCSSValue = analyzeCSSValue(value),
        unitless = _analyzeCSSValue.unitless;

    return unitless || isNumber(value) ? value + "px" : value;
  },
  fraction: function fraction(value) {
    return !isNumber(value) || value > 1 ? value : value * 100 + "%";
  },
  "float": function _float(value, theme) {
    var map = {
      left: "right",
      right: "left"
    };
    return theme.direction === "rtl" ? map[value] : value;
  },
  degree: function degree(value) {
    if (isCssVar(value) || value == null) return value;
    var unitless = isString(value) && !value.endsWith("deg");
    return isNumber(value) || unitless ? value + "deg" : value;
  },
  gradient: gradientTransform,
  blur: wrap("blur"),
  opacity: wrap("opacity"),
  brightness: wrap("brightness"),
  contrast: wrap("contrast"),
  dropShadow: wrap("drop-shadow"),
  grayscale: wrap("grayscale"),
  hueRotate: wrap("hue-rotate"),
  invert: wrap("invert"),
  saturate: wrap("saturate"),
  sepia: wrap("sepia"),
  bgImage: function bgImage(value) {
    if (value == null) return value;
    var prevent = isCSSFunction(value) || globalSet.has(value);
    return !prevent ? "url(" + value + ")" : value;
  },
  outline: function outline(value) {
    var isNoneOrZero = String(value) === "0" || String(value) === "none";
    return value !== null && isNoneOrZero ? {
      outline: "2px solid transparent",
      outlineOffset: "2px"
    } : {
      outline: value
    };
  },
  flexDirection: function flexDirection(value) {
    var _flexDirectionTemplat;

    var _ref = (_flexDirectionTemplat = flexDirectionTemplate[value]) != null ? _flexDirectionTemplat : {},
        space2 = _ref.space,
        divide2 = _ref.divide;

    var result = {
      flexDirection: value
    };
    if (space2) result[space2] = 1;
    if (divide2) result[divide2] = 1;
    return result;
  }
};
var t = {
  borderWidths: toConfig("borderWidths"),
  borderStyles: toConfig("borderStyles"),
  colors: toConfig("colors"),
  borders: toConfig("borders"),
  radii: toConfig("radii", transformFunctions.px),
  space: toConfig("space", transformFunctions.px),
  spaceT: toConfig("space", transformFunctions.px),
  degreeT: function degreeT(property) {
    return {
      property: property,
      transform: transformFunctions.degree
    };
  },
  prop: function prop(property, scale, transform10) {
    return _extends$3({
      property: property,
      scale: scale
    }, scale && {
      transform: createTransform({
        scale: scale,
        transform: transform10
      })
    });
  },
  propT: function propT(property, transform10) {
    return {
      property: property,
      transform: transform10
    };
  },
  sizes: toConfig("sizes", transformFunctions.px),
  sizesT: toConfig("sizes", transformFunctions.fraction),
  shadows: toConfig("shadows"),
  logical: logical,
  blur: toConfig("blur", transformFunctions.blur)
};
var background = {
  background: t.colors("background"),
  backgroundColor: t.colors("backgroundColor"),
  backgroundImage: t.propT("backgroundImage", transformFunctions.bgImage),
  backgroundSize: true,
  backgroundPosition: true,
  backgroundRepeat: true,
  backgroundAttachment: true,
  backgroundClip: {
    transform: transformFunctions.bgClip
  },
  bgSize: t.prop("backgroundSize"),
  bgPosition: t.prop("backgroundPosition"),
  bg: t.colors("background"),
  bgColor: t.colors("backgroundColor"),
  bgPos: t.prop("backgroundPosition"),
  bgRepeat: t.prop("backgroundRepeat"),
  bgAttachment: t.prop("backgroundAttachment"),
  bgGradient: t.propT("backgroundImage", transformFunctions.gradient),
  bgClip: {
    transform: transformFunctions.bgClip
  }
};
Object.assign(background, {
  bgImage: background.backgroundImage,
  bgImg: background.backgroundImage
});
var border = {
  border: t.borders("border"),
  borderWidth: t.borderWidths("borderWidth"),
  borderStyle: t.borderStyles("borderStyle"),
  borderColor: t.colors("borderColor"),
  borderRadius: t.radii("borderRadius"),
  borderTop: t.borders("borderTop"),
  borderBlockStart: t.borders("borderBlockStart"),
  borderTopLeftRadius: t.radii("borderTopLeftRadius"),
  borderStartStartRadius: t.logical({
    scale: "radii",
    property: {
      ltr: "borderTopLeftRadius",
      rtl: "borderTopRightRadius"
    }
  }),
  borderEndStartRadius: t.logical({
    scale: "radii",
    property: {
      ltr: "borderBottomLeftRadius",
      rtl: "borderBottomRightRadius"
    }
  }),
  borderTopRightRadius: t.radii("borderTopRightRadius"),
  borderStartEndRadius: t.logical({
    scale: "radii",
    property: {
      ltr: "borderTopRightRadius",
      rtl: "borderTopLeftRadius"
    }
  }),
  borderEndEndRadius: t.logical({
    scale: "radii",
    property: {
      ltr: "borderBottomRightRadius",
      rtl: "borderBottomLeftRadius"
    }
  }),
  borderRight: t.borders("borderRight"),
  borderInlineEnd: t.borders("borderInlineEnd"),
  borderBottom: t.borders("borderBottom"),
  borderBlockEnd: t.borders("borderBlockEnd"),
  borderBottomLeftRadius: t.radii("borderBottomLeftRadius"),
  borderBottomRightRadius: t.radii("borderBottomRightRadius"),
  borderLeft: t.borders("borderLeft"),
  borderInlineStart: {
    property: "borderInlineStart",
    scale: "borders"
  },
  borderInlineStartRadius: t.logical({
    scale: "radii",
    property: {
      ltr: ["borderTopLeftRadius", "borderBottomLeftRadius"],
      rtl: ["borderTopRightRadius", "borderBottomRightRadius"]
    }
  }),
  borderInlineEndRadius: t.logical({
    scale: "radii",
    property: {
      ltr: ["borderTopRightRadius", "borderBottomRightRadius"],
      rtl: ["borderTopLeftRadius", "borderBottomLeftRadius"]
    }
  }),
  borderX: t.borders(["borderLeft", "borderRight"]),
  borderInline: t.borders("borderInline"),
  borderY: t.borders(["borderTop", "borderBottom"]),
  borderBlock: t.borders("borderBlock"),
  borderTopWidth: t.borderWidths("borderTopWidth"),
  borderBlockStartWidth: t.borderWidths("borderBlockStartWidth"),
  borderTopColor: t.colors("borderTopColor"),
  borderBlockStartColor: t.colors("borderBlockStartColor"),
  borderTopStyle: t.borderStyles("borderTopStyle"),
  borderBlockStartStyle: t.borderStyles("borderBlockStartStyle"),
  borderBottomWidth: t.borderWidths("borderBottomWidth"),
  borderBlockEndWidth: t.borderWidths("borderBlockEndWidth"),
  borderBottomColor: t.colors("borderBottomColor"),
  borderBlockEndColor: t.colors("borderBlockEndColor"),
  borderBottomStyle: t.borderStyles("borderBottomStyle"),
  borderBlockEndStyle: t.borderStyles("borderBlockEndStyle"),
  borderLeftWidth: t.borderWidths("borderLeftWidth"),
  borderInlineStartWidth: t.borderWidths("borderInlineStartWidth"),
  borderLeftColor: t.colors("borderLeftColor"),
  borderInlineStartColor: t.colors("borderInlineStartColor"),
  borderLeftStyle: t.borderStyles("borderLeftStyle"),
  borderInlineStartStyle: t.borderStyles("borderInlineStartStyle"),
  borderRightWidth: t.borderWidths("borderRightWidth"),
  borderInlineEndWidth: t.borderWidths("borderInlineEndWidth"),
  borderRightColor: t.colors("borderRightColor"),
  borderInlineEndColor: t.colors("borderInlineEndColor"),
  borderRightStyle: t.borderStyles("borderRightStyle"),
  borderInlineEndStyle: t.borderStyles("borderInlineEndStyle"),
  borderTopRadius: t.radii(["borderTopLeftRadius", "borderTopRightRadius"]),
  borderBottomRadius: t.radii(["borderBottomLeftRadius", "borderBottomRightRadius"]),
  borderLeftRadius: t.radii(["borderTopLeftRadius", "borderBottomLeftRadius"]),
  borderRightRadius: t.radii(["borderTopRightRadius", "borderBottomRightRadius"])
};
Object.assign(border, {
  rounded: border.borderRadius,
  roundedTop: border.borderTopRadius,
  roundedTopLeft: border.borderTopLeftRadius,
  roundedTopRight: border.borderTopRightRadius,
  roundedTopStart: border.borderStartStartRadius,
  roundedTopEnd: border.borderStartEndRadius,
  roundedBottom: border.borderBottomRadius,
  roundedBottomLeft: border.borderBottomLeftRadius,
  roundedBottomRight: border.borderBottomRightRadius,
  roundedBottomStart: border.borderEndStartRadius,
  roundedBottomEnd: border.borderEndEndRadius,
  roundedLeft: border.borderLeftRadius,
  roundedRight: border.borderRightRadius,
  roundedStart: border.borderInlineStartRadius,
  roundedEnd: border.borderInlineEndRadius,
  borderStart: border.borderInlineStart,
  borderEnd: border.borderInlineEnd,
  borderTopStartRadius: border.borderStartStartRadius,
  borderTopEndRadius: border.borderStartEndRadius,
  borderBottomStartRadius: border.borderEndStartRadius,
  borderBottomEndRadius: border.borderEndEndRadius,
  borderStartRadius: border.borderInlineStartRadius,
  borderEndRadius: border.borderInlineEndRadius,
  borderStartWidth: border.borderInlineStartWidth,
  borderEndWidth: border.borderInlineEndWidth,
  borderStartColor: border.borderInlineStartColor,
  borderEndColor: border.borderInlineEndColor,
  borderStartStyle: border.borderInlineStartStyle,
  borderEndStyle: border.borderInlineEndStyle
});
var color = {
  color: t.colors("color"),
  textColor: t.colors("color"),
  fill: t.colors("fill"),
  stroke: t.colors("stroke")
};
var effect = {
  boxShadow: t.shadows("boxShadow"),
  mixBlendMode: true,
  blendMode: t.prop("mixBlendMode"),
  backgroundBlendMode: true,
  bgBlendMode: t.prop("backgroundBlendMode"),
  opacity: true
};
Object.assign(effect, {
  shadow: effect.boxShadow
});
var filter2 = {
  filter: {
    transform: transformFunctions.filter
  },
  blur: t.blur("--chakra-blur"),
  brightness: t.propT("--chakra-brightness", transformFunctions.brightness),
  contrast: t.propT("--chakra-contrast", transformFunctions.contrast),
  hueRotate: t.degreeT("--chakra-hue-rotate"),
  invert: t.propT("--chakra-invert", transformFunctions.invert),
  saturate: t.propT("--chakra-saturate", transformFunctions.saturate),
  dropShadow: t.propT("--chakra-drop-shadow", transformFunctions.dropShadow),
  backdropFilter: {
    transform: transformFunctions.backdropFilter
  },
  backdropBlur: t.blur("--chakra-backdrop-blur"),
  backdropBrightness: t.propT("--chakra-backdrop-brightness", transformFunctions.brightness),
  backdropContrast: t.propT("--chakra-backdrop-contrast", transformFunctions.contrast),
  backdropHueRotate: t.degreeT("--chakra-backdrop-hue-rotate"),
  backdropInvert: t.propT("--chakra-backdrop-invert", transformFunctions.invert),
  backdropSaturate: t.propT("--chakra-backdrop-saturate", transformFunctions.saturate)
};
var flexbox = {
  alignItems: true,
  alignContent: true,
  justifyItems: true,
  justifyContent: true,
  flexWrap: true,
  flexDirection: {
    transform: transformFunctions.flexDirection
  },
  experimental_spaceX: {
    "static": spaceXTemplate,
    transform: createTransform({
      scale: "space",
      transform: function transform2(value) {
        return value !== null ? {
          "--chakra-space-x": value
        } : null;
      }
    })
  },
  experimental_spaceY: {
    "static": spaceYTemplate,
    transform: createTransform({
      scale: "space",
      transform: function transform3(value) {
        return value != null ? {
          "--chakra-space-y": value
        } : null;
      }
    })
  },
  flex: true,
  flexFlow: true,
  flexGrow: true,
  flexShrink: true,
  flexBasis: t.sizes("flexBasis"),
  justifySelf: true,
  alignSelf: true,
  order: true,
  placeItems: true,
  placeContent: true,
  placeSelf: true,
  gap: t.space("gap"),
  rowGap: t.space("rowGap"),
  columnGap: t.space("columnGap")
};
Object.assign(flexbox, {
  flexDir: flexbox.flexDirection
});
var grid = {
  gridGap: t.space("gridGap"),
  gridColumnGap: t.space("gridColumnGap"),
  gridRowGap: t.space("gridRowGap"),
  gridColumn: true,
  gridRow: true,
  gridAutoFlow: true,
  gridAutoColumns: true,
  gridColumnStart: true,
  gridColumnEnd: true,
  gridRowStart: true,
  gridRowEnd: true,
  gridAutoRows: true,
  gridTemplate: true,
  gridTemplateColumns: true,
  gridTemplateRows: true,
  gridTemplateAreas: true,
  gridArea: true
};
var interactivity = {
  appearance: true,
  cursor: true,
  resize: true,
  userSelect: true,
  pointerEvents: true,
  outline: {
    transform: transformFunctions.outline
  },
  outlineOffset: true,
  outlineColor: t.colors("outlineColor")
};
var layout = {
  width: t.sizesT("width"),
  inlineSize: t.sizesT("inlineSize"),
  height: t.sizes("height"),
  blockSize: t.sizes("blockSize"),
  boxSize: t.sizes(["width", "height"]),
  minWidth: t.sizes("minWidth"),
  minInlineSize: t.sizes("minInlineSize"),
  minHeight: t.sizes("minHeight"),
  minBlockSize: t.sizes("minBlockSize"),
  maxWidth: t.sizes("maxWidth"),
  maxInlineSize: t.sizes("maxInlineSize"),
  maxHeight: t.sizes("maxHeight"),
  maxBlockSize: t.sizes("maxBlockSize"),
  d: t.prop("display"),
  overflow: true,
  overflowX: true,
  overflowY: true,
  overscrollBehavior: true,
  overscrollBehaviorX: true,
  overscrollBehaviorY: true,
  display: true,
  verticalAlign: true,
  boxSizing: true,
  boxDecorationBreak: true,
  "float": t.propT("float", transformFunctions["float"]),
  objectFit: true,
  objectPosition: true,
  visibility: true,
  isolation: true
};
Object.assign(layout, {
  w: layout.width,
  h: layout.height,
  minW: layout.minWidth,
  maxW: layout.maxWidth,
  minH: layout.minHeight,
  maxH: layout.maxHeight,
  overscroll: layout.overscrollBehavior,
  overscrollX: layout.overscrollBehaviorX,
  overscrollY: layout.overscrollBehaviorY
});
var list = {
  listStyleType: true,
  listStylePosition: true,
  listStylePos: t.prop("listStylePosition"),
  listStyleImage: true,
  listStyleImg: t.prop("listStyleImage")
};
var srOnly = {
  border: "0px",
  clip: "rect(0, 0, 0, 0)",
  width: "1px",
  height: "1px",
  margin: "-1px",
  padding: "0px",
  overflow: "hidden",
  whiteSpace: "nowrap",
  position: "absolute"
};
var srFocusable = {
  position: "static",
  width: "auto",
  height: "auto",
  clip: "auto",
  padding: "0",
  margin: "0",
  overflow: "visible",
  whiteSpace: "normal"
};

var getWithPriority = function getWithPriority2(theme, key, styles) {
  var result = {};
  var obj = memoizedGet(theme, key, {});

  for (var prop2 in obj) {
    var isInStyles = prop2 in styles && styles[prop2] != null;
    if (!isInStyles) result[prop2] = obj[prop2];
  }

  return result;
};

var others = {
  srOnly: {
    transform: function transform4(value) {
      if (value === true) return srOnly;
      if (value === "focusable") return srFocusable;
      return {};
    }
  },
  layerStyle: {
    processResult: true,
    transform: function transform5(value, theme, styles) {
      return getWithPriority(theme, "layerStyles." + value, styles);
    }
  },
  textStyle: {
    processResult: true,
    transform: function transform6(value, theme, styles) {
      return getWithPriority(theme, "textStyles." + value, styles);
    }
  },
  apply: {
    processResult: true,
    transform: function transform7(value, theme, styles) {
      return getWithPriority(theme, value, styles);
    }
  }
};
var position = {
  position: true,
  pos: t.prop("position"),
  zIndex: t.prop("zIndex", "zIndices"),
  inset: t.spaceT("inset"),
  insetX: t.spaceT(["left", "right"]),
  insetInline: t.spaceT("insetInline"),
  insetY: t.spaceT(["top", "bottom"]),
  insetBlock: t.spaceT("insetBlock"),
  top: t.spaceT("top"),
  insetBlockStart: t.spaceT("insetBlockStart"),
  bottom: t.spaceT("bottom"),
  insetBlockEnd: t.spaceT("insetBlockEnd"),
  left: t.spaceT("left"),
  insetInlineStart: t.logical({
    scale: "space",
    property: {
      ltr: "left",
      rtl: "right"
    }
  }),
  right: t.spaceT("right"),
  insetInlineEnd: t.logical({
    scale: "space",
    property: {
      ltr: "right",
      rtl: "left"
    }
  })
};
Object.assign(position, {
  insetStart: position.insetInlineStart,
  insetEnd: position.insetInlineEnd
});
var ring2 = {
  ring: {
    transform: transformFunctions.ring
  },
  ringColor: t.colors("--chakra-ring-color"),
  ringOffset: t.prop("--chakra-ring-offset-width"),
  ringOffsetColor: t.colors("--chakra-ring-offset-color"),
  ringInset: t.prop("--chakra-ring-inset")
};
var space = {
  margin: t.spaceT("margin"),
  marginTop: t.spaceT("marginTop"),
  marginBlockStart: t.spaceT("marginBlockStart"),
  marginRight: t.spaceT("marginRight"),
  marginInlineEnd: t.spaceT("marginInlineEnd"),
  marginBottom: t.spaceT("marginBottom"),
  marginBlockEnd: t.spaceT("marginBlockEnd"),
  marginLeft: t.spaceT("marginLeft"),
  marginInlineStart: t.spaceT("marginInlineStart"),
  marginX: t.spaceT(["marginInlineStart", "marginInlineEnd"]),
  marginInline: t.spaceT("marginInline"),
  marginY: t.spaceT(["marginTop", "marginBottom"]),
  marginBlock: t.spaceT("marginBlock"),
  padding: t.space("padding"),
  paddingTop: t.space("paddingTop"),
  paddingBlockStart: t.space("paddingBlockStart"),
  paddingRight: t.space("paddingRight"),
  paddingBottom: t.space("paddingBottom"),
  paddingBlockEnd: t.space("paddingBlockEnd"),
  paddingLeft: t.space("paddingLeft"),
  paddingInlineStart: t.space("paddingInlineStart"),
  paddingInlineEnd: t.space("paddingInlineEnd"),
  paddingX: t.space(["paddingInlineStart", "paddingInlineEnd"]),
  paddingInline: t.space("paddingInline"),
  paddingY: t.space(["paddingTop", "paddingBottom"]),
  paddingBlock: t.space("paddingBlock")
};
Object.assign(space, {
  m: space.margin,
  mt: space.marginTop,
  mr: space.marginRight,
  me: space.marginInlineEnd,
  marginEnd: space.marginInlineEnd,
  mb: space.marginBottom,
  ml: space.marginLeft,
  ms: space.marginInlineStart,
  marginStart: space.marginInlineStart,
  mx: space.marginX,
  my: space.marginY,
  p: space.padding,
  pt: space.paddingTop,
  py: space.paddingY,
  px: space.paddingX,
  pb: space.paddingBottom,
  pl: space.paddingLeft,
  ps: space.paddingInlineStart,
  paddingStart: space.paddingInlineStart,
  pr: space.paddingRight,
  pe: space.paddingInlineEnd,
  paddingEnd: space.paddingInlineEnd
});
var textDecoration = {
  textDecorationColor: t.colors("textDecorationColor"),
  textDecoration: true,
  textDecor: {
    property: "textDecoration"
  },
  textDecorationLine: true,
  textDecorationStyle: true,
  textDecorationThickness: true,
  textUnderlineOffset: true,
  textShadow: t.shadows("textShadow")
};
var transform8 = {
  clipPath: true,
  transform: t.propT("transform", transformFunctions.transform),
  transformOrigin: true,
  translateX: t.spaceT("--chakra-translate-x"),
  translateY: t.spaceT("--chakra-translate-y"),
  skewX: t.degreeT("--chakra-skew-x"),
  skewY: t.degreeT("--chakra-skew-y"),
  scaleX: t.prop("--chakra-scale-x"),
  scaleY: t.prop("--chakra-scale-y"),
  scale: t.prop(["--chakra-scale-x", "--chakra-scale-y"]),
  rotate: t.degreeT("--chakra-rotate")
};
var transition = {
  transition: true,
  transitionDelay: true,
  animation: true,
  willChange: true,
  transitionDuration: t.prop("transitionDuration", "transition.duration"),
  transitionProperty: t.prop("transitionProperty", "transition.property"),
  transitionTimingFunction: t.prop("transitionTimingFunction", "transition.easing")
};
var typography = {
  fontFamily: t.prop("fontFamily", "fonts"),
  fontSize: t.prop("fontSize", "fontSizes", transformFunctions.px),
  fontWeight: t.prop("fontWeight", "fontWeights"),
  lineHeight: t.prop("lineHeight", "lineHeights"),
  letterSpacing: t.prop("letterSpacing", "letterSpacings"),
  textAlign: true,
  fontStyle: true,
  wordBreak: true,
  overflowWrap: true,
  textOverflow: true,
  textTransform: true,
  whiteSpace: true,
  noOfLines: {
    "static": {
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "-webkit-box",
      WebkitBoxOrient: "vertical",
      //@ts-ignore
      WebkitLineClamp: "var(--chakra-line-clamp)"
    },
    property: "--chakra-line-clamp"
  },
  isTruncated: {
    transform: function transform9(value) {
      if (value === true) {
        return {
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        };
      }
    }
  }
};
var scroll = {
  scrollBehavior: true,
  scrollSnapAlign: true,
  scrollSnapStop: true,
  scrollSnapType: true,
  // scroll margin
  scrollMargin: t.spaceT("scrollMargin"),
  scrollMarginTop: t.spaceT("scrollMarginTop"),
  scrollMarginBottom: t.spaceT("scrollMarginBottom"),
  scrollMarginLeft: t.spaceT("scrollMarginLeft"),
  scrollMarginRight: t.spaceT("scrollMarginRight"),
  scrollMarginX: t.spaceT(["scrollMarginLeft", "scrollMarginRight"]),
  scrollMarginY: t.spaceT(["scrollMarginTop", "scrollMarginBottom"]),
  // scroll padding
  scrollPadding: t.spaceT("scrollPadding"),
  scrollPaddingTop: t.spaceT("scrollPaddingTop"),
  scrollPaddingBottom: t.spaceT("scrollPaddingBottom"),
  scrollPaddingLeft: t.spaceT("scrollPaddingLeft"),
  scrollPaddingRight: t.spaceT("scrollPaddingRight"),
  scrollPaddingX: t.spaceT(["scrollPaddingLeft", "scrollPaddingRight"]),
  scrollPaddingY: t.spaceT(["scrollPaddingTop", "scrollPaddingBottom"])
};

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var state = {
  hover: function hover(str, post) {
    return str + ":hover " + post + ", " + str + "[data-hover] " + post;
  },
  focus: function focus(str, post) {
    return str + ":focus " + post + ", " + str + "[data-focus] " + post;
  },
  focusVisible: function focusVisible(str, post) {
    return str + ":focus-visible " + post;
  },
  focusWithin: function focusWithin(str, post) {
    return str + ":focus-within " + post;
  },
  active: function active(str, post) {
    return str + ":active " + post + ", " + str + "[data-active] " + post;
  },
  disabled: function disabled(str, post) {
    return str + ":disabled " + post + ", " + str + "[data-disabled] " + post;
  },
  invalid: function invalid(str, post) {
    return str + ":invalid " + post + ", " + str + "[data-invalid] " + post;
  },
  checked: function checked(str, post) {
    return str + ":checked " + post + ", " + str + "[data-checked] " + post;
  },
  indeterminate: function indeterminate(str, post) {
    return str + ":indeterminate " + post + ", " + str + "[aria-checked=mixed] " + post + ", " + str + "[data-indeterminate] " + post;
  },
  readOnly: function readOnly(str, post) {
    return str + ":read-only " + post + ", " + str + "[readonly] " + post + ", " + str + "[data-read-only] " + post;
  },
  expanded: function expanded(str, post) {
    return str + ":read-only " + post + ", " + str + "[aria-expanded=true] " + post + ", " + str + "[data-expanded] " + post;
  },
  placeholderShown: function placeholderShown(str, post) {
    return str + ":placeholder-shown " + post;
  }
};

var toGroup = function toGroup2(fn) {
  return merge(function (v) {
    return fn(v, "&");
  }, "[role=group]", "[data-group]", ".group");
};

var toPeer = function toPeer2(fn) {
  return merge(function (v) {
    return fn(v, "~ &");
  }, "[data-peer]", ".peer");
};

var merge = function merge2(fn) {
  for (var _len = arguments.length, selectors = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    selectors[_key - 1] = arguments[_key];
  }

  return selectors.map(fn).join(", ");
};

var pseudoSelectors = {
  /**
   * Styles for CSS selector `&:hover`
   */
  _hover: "&:hover, &[data-hover]",

  /**
   * Styles for CSS Selector `&:active`
   */
  _active: "&:active, &[data-active]",

  /**
   * Styles for CSS selector `&:focus`
   *
   */
  _focus: "&:focus, &[data-focus]",

  /**
   * Styles for the highlighted state.
   */
  _highlighted: "&[data-highlighted]",

  /**
   * Styles to apply when a child of this element has received focus
   * - CSS Selector `&:focus-within`
   */
  _focusWithin: "&:focus-within",

  /**
   * Styles to apply when this element has received focus via tabbing
   * - CSS Selector `&:focus-visible`
   */
  _focusVisible: "&:focus-visible",

  /**
   * Styles to apply when this element is disabled. The passed styles are applied to these CSS selectors:
   * - `&[aria-disabled=true]`
   * - `&:disabled`
   * - `&[data-disabled]`
   */
  _disabled: "&[disabled], &[aria-disabled=true], &[data-disabled]",

  /**
   * Styles for CSS Selector `&:readonly`
   */
  _readOnly: "&[aria-readonly=true], &[readonly], &[data-readonly]",

  /**
   * Styles for CSS selector `&::before`
   *
   * NOTE:When using this, ensure the `content` is wrapped in a backtick.
   * @example
   * ```jsx
   * <Box _before={{content:`""` }}/>
   * ```
   */
  _before: "&::before",

  /**
   * Styles for CSS selector `&::after`
   *
   * NOTE:When using this, ensure the `content` is wrapped in a backtick.
   * @example
   * ```jsx
   * <Box _after={{content:`""` }}/>
   * ```
   */
  _after: "&::after",

  /**
   * Styles for CSS selector `&:empty`
   */
  _empty: "&:empty",

  /**
   * Styles to apply when the ARIA attribute `aria-expanded` is `true`
   * - CSS selector `&[aria-expanded=true]`
   */
  _expanded: "&[aria-expanded=true], &[data-expanded]",

  /**
   * Styles to apply when the ARIA attribute `aria-checked` is `true`
   * - CSS selector `&[aria-checked=true]`
   */
  _checked: "&[aria-checked=true], &[data-checked]",

  /**
   * Styles to apply when the ARIA attribute `aria-grabbed` is `true`
   * - CSS selector `&[aria-grabbed=true]`
   */
  _grabbed: "&[aria-grabbed=true], &[data-grabbed]",

  /**
   * Styles for CSS Selector `&[aria-pressed=true]`
   * Typically used to style the current "pressed" state of toggle buttons
   */
  _pressed: "&[aria-pressed=true], &[data-pressed]",

  /**
   * Styles to apply when the ARIA attribute `aria-invalid` is `true`
   * - CSS selector `&[aria-invalid=true]`
   */
  _invalid: "&[aria-invalid=true], &[data-invalid]",

  /**
   * Styles for the valid state
   * - CSS selector `&[data-valid], &[data-state=valid]`
   */
  _valid: "&[data-valid], &[data-state=valid]",

  /**
   * Styles for CSS Selector `&[aria-busy=true]` or `&[data-loading=true]`.
   * Useful for styling loading states
   */
  _loading: "&[data-loading], &[aria-busy=true]",

  /**
   * Styles to apply when the ARIA attribute `aria-selected` is `true`
   *
   * - CSS selector `&[aria-selected=true]`
   */
  _selected: "&[aria-selected=true], &[data-selected]",

  /**
   * Styles for CSS Selector `[hidden=true]`
   */
  _hidden: "&[hidden], &[data-hidden]",

  /**
   * Styles for CSS Selector `&:-webkit-autofill`
   */
  _autofill: "&:-webkit-autofill",

  /**
   * Styles for CSS Selector `&:nth-child(even)`
   */
  _even: "&:nth-of-type(even)",

  /**
   * Styles for CSS Selector `&:nth-child(odd)`
   */
  _odd: "&:nth-of-type(odd)",

  /**
   * Styles for CSS Selector `&:first-of-type`
   */
  _first: "&:first-of-type",

  /**
   * Styles for CSS Selector `&:last-of-type`
   */
  _last: "&:last-of-type",

  /**
   * Styles for CSS Selector `&:not(:first-of-type)`
   */
  _notFirst: "&:not(:first-of-type)",

  /**
   * Styles for CSS Selector `&:not(:last-of-type)`
   */
  _notLast: "&:not(:last-of-type)",

  /**
   * Styles for CSS Selector `&:visited`
   */
  _visited: "&:visited",

  /**
   * Used to style the active link in a navigation
   * Styles for CSS Selector `&[aria-current=page]`
   */
  _activeLink: "&[aria-current=page]",

  /**
   * Used to style the current step within a process
   * Styles for CSS Selector `&[aria-current=step]`
   */
  _activeStep: "&[aria-current=step]",

  /**
   * Styles to apply when the ARIA attribute `aria-checked` is `mixed`
   * - CSS selector `&[aria-checked=mixed]`
   */
  _indeterminate: "&:indeterminate, &[aria-checked=mixed], &[data-indeterminate]",

  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is hovered
   */
  _groupHover: toGroup(state.hover),

  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is hovered
   */
  _peerHover: toPeer(state.hover),

  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is focused
   */
  _groupFocus: toGroup(state.focus),

  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is focused
   */
  _peerFocus: toPeer(state.focus),

  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` has visible focus
   */
  _groupFocusVisible: toGroup(state.focusVisible),

  /**
   * Styles to apply when a sibling element with `.peer`or `data-peer` has visible focus
   */
  _peerFocusVisible: toPeer(state.focusVisible),

  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is active
   */
  _groupActive: toGroup(state.active),

  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is active
   */
  _peerActive: toPeer(state.active),

  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is disabled
   */
  _groupDisabled: toGroup(state.disabled),

  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` is disabled
   */
  _peerDisabled: toPeer(state.disabled),

  /**
   *  Styles to apply when a parent element with `.group`, `data-group` or `role=group` is invalid
   */
  _groupInvalid: toGroup(state.invalid),

  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` is invalid
   */
  _peerInvalid: toPeer(state.invalid),

  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is checked
   */
  _groupChecked: toGroup(state.checked),

  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is checked
   */
  _peerChecked: toPeer(state.checked),

  /**
   *  Styles to apply when a parent element with `.group`, `data-group` or `role=group` has focus within
   */
  _groupFocusWithin: toGroup(state.focusWithin),

  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` has focus within
   */
  _peerFocusWithin: toPeer(state.focusWithin),

  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` has placeholder shown
   */
  _peerPlaceholderShown: toPeer(state.placeholderShown),

  /**
   * Styles for CSS Selector `&::placeholder`.
   */
  _placeholder: "&::placeholder",

  /**
   * Styles for CSS Selector `&:placeholder-shown`.
   */
  _placeholderShown: "&:placeholder-shown",

  /**
   * Styles for CSS Selector `&:fullscreen`.
   */
  _fullScreen: "&:fullscreen",

  /**
   * Styles for CSS Selector `&::selection`
   */
  _selection: "&::selection",

  /**
   * Styles for CSS Selector `[dir=rtl] &`
   * It is applied when a parent element or this element has `dir="rtl"`
   */
  _rtl: "[dir=rtl] &, &[dir=rtl]",

  /**
   * Styles for CSS Selector `[dir=ltr] &`
   * It is applied when a parent element or this element has `dir="ltr"`
   */
  _ltr: "[dir=ltr] &, &[dir=ltr]",

  /**
   * Styles for CSS Selector `@media (prefers-color-scheme: dark)`
   * It is used when the user has requested the system use a light or dark color theme.
   */
  _mediaDark: "@media (prefers-color-scheme: dark)",

  /**
   * Styles for CSS Selector `@media (prefers-reduced-motion: reduce)`
   * It is used when the user has requested the system to reduce the amount of animations.
   */
  _mediaReduceMotion: "@media (prefers-reduced-motion: reduce)",

  /**
   * Styles for when `data-theme` is applied to any parent of
   * this component or element.
   */
  _dark: ".chakra-ui-dark &:not([data-theme]),[data-theme=dark] &:not([data-theme]),&[data-theme=dark]",

  /**
   * Styles for when `data-theme` is applied to any parent of
   * this component or element.
   */
  _light: ".chakra-ui-light &:not([data-theme]),[data-theme=light] &:not([data-theme]),&[data-theme=light]"
};
var pseudoPropNames = objectKeys(pseudoSelectors);
var systemProps = mergeWith({}, background, border, color, flexbox, layout, filter2, ring2, interactivity, grid, others, position, effect, space, scroll, typography, textDecoration, transform8, list, transition);
Object.assign({}, space, layout, flexbox, grid, position);
var propNames = [].concat(objectKeys(systemProps), pseudoPropNames);

var styleProps = _extends$3({}, systemProps, pseudoSelectors);

var isStyleProp = function isStyleProp2(prop2) {
  return prop2 in styleProps;
};

var expandResponsive = function expandResponsive2(styles) {
  return function (theme) {
    if (!theme.__breakpoints) return styles;
    var _theme$__breakpoints = theme.__breakpoints,
        isResponsive = _theme$__breakpoints.isResponsive,
        toArrayValue = _theme$__breakpoints.toArrayValue,
        medias = _theme$__breakpoints.media;
    var computedStyles = {};

    for (var key in styles) {
      var value = runIfFn(styles[key], theme);
      if (value == null) continue;
      value = isObject(value) && isResponsive(value) ? toArrayValue(value) : value;

      if (!Array.isArray(value)) {
        computedStyles[key] = value;
        continue;
      }

      var queries = value.slice(0, medias.length).length;

      for (var index = 0; index < queries; index += 1) {
        var media = medias == null ? void 0 : medias[index];

        if (!media) {
          computedStyles[key] = value[index];
          continue;
        }

        computedStyles[media] = computedStyles[media] || {};

        if (value[index] == null) {
          continue;
        }

        computedStyles[media][key] = value[index];
      }
    }

    return computedStyles;
  };
};

var isCSSVariableTokenValue = function isCSSVariableTokenValue2(key, value) {
  return key.startsWith("--") && isString(value) && !isCssVar(value);
};

var resolveTokenValue = function resolveTokenValue2(theme, value) {
  var _ref, _getVar2;

  if (value == null) return value;

  var getVar = function getVar2(val) {
    var _theme$__cssMap, _theme$__cssMap$val;

    return (_theme$__cssMap = theme.__cssMap) == null ? void 0 : (_theme$__cssMap$val = _theme$__cssMap[val]) == null ? void 0 : _theme$__cssMap$val.varRef;
  };

  var getValue = function getValue2(val) {
    var _getVar;

    return (_getVar = getVar(val)) != null ? _getVar : val;
  };

  var valueSplit = value.split(",").map(function (v) {
    return v.trim();
  });
  var tokenValue = valueSplit[0],
      fallbackValue = valueSplit[1];
  value = (_ref = (_getVar2 = getVar(tokenValue)) != null ? _getVar2 : getValue(fallbackValue)) != null ? _ref : getValue(value);
  return value;
};

function getCss(options) {
  var _options$configs = options.configs,
      configs = _options$configs === void 0 ? {} : _options$configs,
      _options$pseudos = options.pseudos,
      pseudos = _options$pseudos === void 0 ? {} : _options$pseudos,
      theme = options.theme;

  var css3 = function css4(stylesOrFn, nested) {
    if (nested === void 0) {
      nested = false;
    }

    var _styles = runIfFn(stylesOrFn, theme);

    var styles = expandResponsive(_styles)(theme);
    var computedStyles = {};

    for (var key in styles) {
      var _config$transform, _config, _config2, _config3, _config4;

      var valueOrFn = styles[key];
      var value = runIfFn(valueOrFn, theme);

      if (key in pseudos) {
        key = pseudos[key];
      }

      if (isCSSVariableTokenValue(key, value)) {
        value = resolveTokenValue(theme, value);
      }

      var config = configs[key];

      if (config === true) {
        config = {
          property: key
        };
      }

      if (isObject(value)) {
        var _computedStyles$key;

        computedStyles[key] = (_computedStyles$key = computedStyles[key]) != null ? _computedStyles$key : {};
        computedStyles[key] = mergeWith({}, computedStyles[key], css4(value, true));
        continue;
      }

      var rawValue = (_config$transform = (_config = config) == null ? void 0 : _config.transform == null ? void 0 : _config.transform(value, theme, _styles)) != null ? _config$transform : value;
      rawValue = (_config2 = config) != null && _config2.processResult ? css4(rawValue, true) : rawValue;
      var configProperty = runIfFn((_config3 = config) == null ? void 0 : _config3.property, theme);

      if (!nested && (_config4 = config) != null && _config4["static"]) {
        var staticStyles = runIfFn(config["static"], theme);
        computedStyles = mergeWith({}, computedStyles, staticStyles);
      }

      if (configProperty && Array.isArray(configProperty)) {
        for (var _iterator = _createForOfIteratorHelperLoose(configProperty), _step; !(_step = _iterator()).done;) {
          var property = _step.value;
          computedStyles[property] = rawValue;
        }

        continue;
      }

      if (configProperty) {
        if (configProperty === "&" && isObject(rawValue)) {
          computedStyles = mergeWith({}, computedStyles, rawValue);
        } else {
          computedStyles[configProperty] = rawValue;
        }

        continue;
      }

      if (isObject(rawValue)) {
        computedStyles = mergeWith({}, computedStyles, rawValue);
        continue;
      }

      computedStyles[key] = rawValue;
    }

    return computedStyles;
  };

  return css3;
}

var css = function css2(styles) {
  return function (theme) {
    var cssFn = getCss({
      theme: theme,
      pseudos: pseudoSelectors,
      configs: systemProps
    });
    return cssFn(styles);
  };
};

function resolveReference(operand) {
  if (isObject(operand) && operand.reference) {
    return operand.reference;
  }

  return String(operand);
}

var toExpression = function toExpression2(operator) {
  for (var _len = arguments.length, operands = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    operands[_key - 1] = arguments[_key];
  }

  return operands.map(resolveReference).join(" " + operator + " ").replace(/calc/g, "");
};

var _add = function add() {
  for (var _len2 = arguments.length, operands = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    operands[_key2] = arguments[_key2];
  }

  return "calc(" + toExpression.apply(void 0, ["+"].concat(operands)) + ")";
};

var _subtract = function subtract() {
  for (var _len3 = arguments.length, operands = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    operands[_key3] = arguments[_key3];
  }

  return "calc(" + toExpression.apply(void 0, ["-"].concat(operands)) + ")";
};

var _multiply = function multiply() {
  for (var _len4 = arguments.length, operands = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    operands[_key4] = arguments[_key4];
  }

  return "calc(" + toExpression.apply(void 0, ["*"].concat(operands)) + ")";
};

var _divide = function divide() {
  for (var _len5 = arguments.length, operands = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    operands[_key5] = arguments[_key5];
  }

  return "calc(" + toExpression.apply(void 0, ["/"].concat(operands)) + ")";
};

var _negate = function negate(x) {
  var value = resolveReference(x);

  if (value != null && !Number.isNaN(parseFloat(value))) {
    return String(value).startsWith("-") ? String(value).slice(1) : "-" + value;
  }

  return _multiply(value, -1);
};

var calc = Object.assign(function (x) {
  return {
    add: function add2() {
      for (var _len6 = arguments.length, operands = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        operands[_key6] = arguments[_key6];
      }

      return calc(_add.apply(void 0, [x].concat(operands)));
    },
    subtract: function subtract2() {
      for (var _len7 = arguments.length, operands = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        operands[_key7] = arguments[_key7];
      }

      return calc(_subtract.apply(void 0, [x].concat(operands)));
    },
    multiply: function multiply2() {
      for (var _len8 = arguments.length, operands = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
        operands[_key8] = arguments[_key8];
      }

      return calc(_multiply.apply(void 0, [x].concat(operands)));
    },
    divide: function divide2() {
      for (var _len9 = arguments.length, operands = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
        operands[_key9] = arguments[_key9];
      }

      return calc(_divide.apply(void 0, [x].concat(operands)));
    },
    negate: function negate2() {
      return calc(_negate(x));
    },
    toString: function toString() {
      return x.toString();
    }
  };
}, {
  add: _add,
  subtract: _subtract,
  multiply: _multiply,
  divide: _divide,
  negate: _negate
});
var hasElementType = typeof Element !== "undefined";
var hasMap = typeof Map === "function";
var hasSet = typeof Set === "function";
var hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;

function equal(a, b) {
  if (a === b) return true;

  if (a && b && _typeof(a) == "object" && _typeof(b) == "object") {
    if (a.constructor !== b.constructor) return false;
    var length, i, keys;

    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;

      for (i = length; i-- !== 0;) {
        if (!equal(a[i], b[i])) return false;
      }

      return true;
    }

    var it;

    if (hasMap && a instanceof Map && b instanceof Map) {
      if (a.size !== b.size) return false;
      it = a.entries();

      while (!(i = it.next()).done) {
        if (!b.has(i.value[0])) return false;
      }

      it = a.entries();

      while (!(i = it.next()).done) {
        if (!equal(i.value[1], b.get(i.value[0]))) return false;
      }

      return true;
    }

    if (hasSet && a instanceof Set && b instanceof Set) {
      if (a.size !== b.size) return false;
      it = a.entries();

      while (!(i = it.next()).done) {
        if (!b.has(i.value[0])) return false;
      }

      return true;
    }

    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;

      for (i = length; i-- !== 0;) {
        if (a[i] !== b[i]) return false;
      }

      return true;
    }

    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;) {
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    }

    if (hasElementType && a instanceof Element) return false;

    for (i = length; i-- !== 0;) {
      if ((keys[i] === "_owner" || keys[i] === "__v" || keys[i] === "__o") && a.$$typeof) {
        continue;
      }

      if (!equal(a[keys[i]], b[keys[i]])) return false;
    }

    return true;
  }

  return a !== a && b !== b;
}

var reactFastCompare = function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if ((error.message || "").match(/stack|recursion/i)) {
      console.warn("react-fast-compare cannot handle circular refs");
      return false;
    }

    throw error;
  }
};

var isEqual2 =
/* @__PURE__ */
getDefaultExportFromCjs(reactFastCompare);

function createContext(options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$strict = _options.strict,
      strict = _options$strict === void 0 ? true : _options$strict,
      _options$errorMessage = _options.errorMessage,
      errorMessage = _options$errorMessage === void 0 ? "useContext: `context` is undefined. Seems you forgot to wrap component within the Provider" : _options$errorMessage,
      name = _options.name;
  var Context =
  /* @__PURE__ */
  React.createContext(void 0);
  Context.displayName = name;

  function useContext() {
    var context = React.useContext(Context);

    if (!context && strict) {
      var error = new Error(errorMessage);
      error.name = "ContextError";
      Error.captureStackTrace == null ? void 0 : Error.captureStackTrace(error, useContext);
      throw error;
    }

    return context;
  }

  return [Context.Provider, useContext, Context];
}

function getValidChildren(children) {
  return React.Children.toArray(children).filter(function (child) {
    return (
      /* @__PURE__ */
      React.isValidElement(child)
    );
  });
}

function _extends$2() {
  _extends$2 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$2.apply(this, arguments);
}

function useTheme() {
  var theme = React.useContext(ThemeContext);

  if (!theme) {
    throw Error("useTheme: `theme` is undefined. Seems you forgot to wrap your app in `<ChakraProvider />` or `<ThemeProvider />`");
  }

  return theme;
}

createContext({
  name: "StylesContext",
  errorMessage: "useStyles: `styles` is undefined. Seems you forgot to wrap the components in `<StylesProvider />` "
});

function omitThemingProps(props) {
  return omit(props, ["styleConfig", "size", "variant", "colorScheme"]);
}

function useChakra() {
  var colorModeResult = useColorMode();
  var theme = useTheme();
  return _extends$2({}, colorModeResult, {
    theme: theme
  });
}

function _objectWithoutPropertiesLoose$2(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var allPropNames = new Set([].concat(propNames, ["textStyle", "layerStyle", "apply", "isTruncated", "noOfLines", "focusBorderColor", "errorBorderColor", "as", "__css", "css", "sx"]));
var validHTMLProps =
/* @__PURE__ */
new Set(["htmlWidth", "htmlHeight", "htmlSize"]);

var shouldForwardProp = function shouldForwardProp2(prop2) {
  return validHTMLProps.has(prop2) || !allPropNames.has(prop2);
};

var _excluded$1$1 = ["theme", "css", "__css", "sx"],
    _excluded2 = ["baseStyle"];

var toCSSObject = function toCSSObject2(_ref) {
  var baseStyle = _ref.baseStyle;
  return function (props) {
    props.theme;

    var cssProp = props.css,
        __css = props.__css,
        sx = props.sx,
        rest = _objectWithoutPropertiesLoose$2(props, _excluded$1$1);

    var styleProps2 = objectFilter(rest, function (_, prop2) {
      return isStyleProp(prop2);
    });
    var finalBaseStyle = runIfFn(baseStyle, props);
    var finalStyles = Object.assign({}, __css, finalBaseStyle, filterUndefined(styleProps2), sx);
    var computedCSS = css(finalStyles)(props.theme);
    return cssProp ? [computedCSS, cssProp] : computedCSS;
  };
};

function styled(component, options) {
  var _ref2 = options != null ? options : {},
      baseStyle = _ref2.baseStyle,
      styledOptions = _objectWithoutPropertiesLoose$2(_ref2, _excluded2);

  if (!styledOptions.shouldForwardProp) {
    styledOptions.shouldForwardProp = shouldForwardProp;
  }

  var styleObject = toCSSObject({
    baseStyle: baseStyle
  });
  return _styled(component, styledOptions)(styleObject);
}

function forwardRef(component) {
  return (
    /* @__PURE__ */
    React.forwardRef(component)
  );
}

var _excluded$e = ["styleConfig"];

function useStyleConfig(themeKey, props, opts) {
  var _styleConfig$defaultP;

  if (props === void 0) {
    props = {};
  }

  if (opts === void 0) {
    opts = {};
  }

  var _props = props,
      styleConfigProp = _props.styleConfig,
      rest = _objectWithoutPropertiesLoose$2(_props, _excluded$e);

  var _useChakra = useChakra(),
      theme = _useChakra.theme,
      colorMode = _useChakra.colorMode;

  var themeStyleConfig = memoizedGet(theme, "components." + themeKey);
  var styleConfig = styleConfigProp || themeStyleConfig;
  var mergedProps = mergeWith({
    theme: theme,
    colorMode: colorMode
  }, (_styleConfig$defaultP = styleConfig == null ? void 0 : styleConfig.defaultProps) != null ? _styleConfig$defaultP : {}, filterUndefined(omit(rest, ["children"])));
  var stylesRef = useRef({});

  if (styleConfig) {
    var _styleConfig$baseStyl, _styleConfig$variants, _styleConfig$variants2, _styleConfig$sizes$me, _styleConfig$sizes, _opts;

    var baseStyles = runIfFn((_styleConfig$baseStyl = styleConfig.baseStyle) != null ? _styleConfig$baseStyl : {}, mergedProps);
    var variants = runIfFn((_styleConfig$variants = (_styleConfig$variants2 = styleConfig.variants) == null ? void 0 : _styleConfig$variants2[mergedProps.variant]) != null ? _styleConfig$variants : {}, mergedProps);
    var sizes = runIfFn((_styleConfig$sizes$me = (_styleConfig$sizes = styleConfig.sizes) == null ? void 0 : _styleConfig$sizes[mergedProps.size]) != null ? _styleConfig$sizes$me : {}, mergedProps);
    var styles = mergeWith({}, baseStyles, sizes, variants);

    if ((_opts = opts) != null && _opts.isMultiPart && styleConfig.parts) {
      styleConfig.parts.forEach(function (part) {
        var _styles$part;

        styles[part] = (_styles$part = styles[part]) != null ? _styles$part : {};
      });
    }

    var isStyleEqual = isEqual2(stylesRef.current, styles);

    if (!isStyleEqual) {
      stylesRef.current = styles;
    }
  }

  return stylesRef.current;
}

function useMultiStyleConfig(themeKey, props) {
  return useStyleConfig(themeKey, props, {
    isMultiPart: true
  });
}

function factory() {
  var cache =
  /* @__PURE__ */
  new Map();
  return new Proxy(styled, {
    /**
     * @example
     * const Div = chakra("div")
     * const WithChakra = chakra(AnotherComponent)
     */
    apply: function apply(target, thisArg, argArray) {
      return styled.apply(void 0, argArray);
    },

    /**
     * @example
     * <chakra.div />
     */
    get: function get2(_, element) {
      if (!cache.has(element)) {
        cache.set(element, styled(element));
      }

      return cache.get(element);
    }
  });
}

var chakra = factory();

function _extends$1() {
  _extends$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1.apply(this, arguments);
}

function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var _excluded = ["as", "viewBox", "color", "focusable", "children", "className", "__css"];
var fallbackIcon = {
  path:
  /* @__PURE__ */
  React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: "1.5"
  },
  /* @__PURE__ */
  React.createElement("path", {
    strokeLinecap: "round",
    fill: "none",
    d: "M9,9a3,3,0,1,1,4,2.829,1.5,1.5,0,0,0-1,1.415V14.25"
  }),
  /* @__PURE__ */
  React.createElement("path", {
    fill: "currentColor",
    strokeLinecap: "round",
    d: "M12,17.25a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,17.25h0"
  }),
  /* @__PURE__ */
  React.createElement("circle", {
    fill: "none",
    strokeMiterlimit: "10",
    cx: "12",
    cy: "12",
    r: "11.25"
  })),
  viewBox: "0 0 24 24"
};
var Icon =
/* @__PURE__ */
forwardRef(function (props, ref) {
  var element = props.as,
      viewBox = props.viewBox,
      _props$color = props.color,
      color2 = _props$color === void 0 ? "currentColor" : _props$color,
      _props$focusable = props.focusable,
      focusable = _props$focusable === void 0 ? false : _props$focusable,
      children = props.children,
      className = props.className,
      __css = props.__css,
      rest = _objectWithoutPropertiesLoose$1(props, _excluded);

  var _className = cx("chakra-icon", className);

  var styles = _extends$1({
    w: "1em",
    h: "1em",
    display: "inline-block",
    lineHeight: "1em",
    flexShrink: 0,
    color: color2
  }, __css);

  var shared = {
    ref: ref,
    focusable: focusable,
    className: _className,
    __css: styles
  };

  var _viewBox = viewBox != null ? viewBox : fallbackIcon.viewBox;

  if (element && typeof element !== "string") {
    return (
      /* @__PURE__ */
      React.createElement(chakra.svg, _extends$1({
        as: element
      }, shared, rest))
    );
  }

  var _path = children != null ? children : fallbackIcon.path;

  return (
    /* @__PURE__ */
    React.createElement(chakra.svg, _extends$1({
      verticalAlign: "middle",
      viewBox: _viewBox
    }, shared, rest), _path)
  );
});

if (__DEV__) {
  Icon.displayName = "Icon";
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var _excluded$h = ["ratio", "children", "className"];
var AspectRatio =
/* @__PURE__ */
forwardRef(function (props, ref) {
  var _props$ratio = props.ratio,
      ratio = _props$ratio === void 0 ? 4 / 3 : _props$ratio,
      children = props.children,
      className = props.className,
      rest = _objectWithoutPropertiesLoose(props, _excluded$h);

  var child = React.Children.only(children);

  var _className = cx("chakra-aspect-ratio", className);

  return (
    /* @__PURE__ */
    React.createElement(chakra.div, _extends({
      ref: ref,
      position: "relative",
      className: _className,
      _before: {
        height: 0,
        content: '""',
        display: "block",
        paddingBottom: mapResponsive(ratio, function (r) {
          return 1 / r * 100 + "%";
        })
      },
      __css: {
        "& > *:not(style)": {
          overflow: "hidden",
          position: "absolute",
          top: "0",
          right: "0",
          bottom: "0",
          left: "0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          height: "100%"
        },
        "& > img, & > video": {
          objectFit: "cover"
        }
      }
    }, rest), child)
  );
});

if (__DEV__) {
  AspectRatio.displayName = "AspectRatio";
}

var _excluded$g = ["className"];
var Badge =
/* @__PURE__ */
forwardRef(function (props, ref) {
  var styles = useStyleConfig("Badge", props);

  var _omitThemingProps = omitThemingProps(props);

  _omitThemingProps.className;

  var rest = _objectWithoutPropertiesLoose(_omitThemingProps, _excluded$g);

  return (
    /* @__PURE__ */
    React.createElement(chakra.span, _extends({
      ref: ref,
      className: cx("chakra-badge", props.className)
    }, rest, {
      __css: _extends({
        display: "inline-block",
        whiteSpace: "nowrap",
        verticalAlign: "middle"
      }, styles)
    }))
  );
});

if (__DEV__) {
  Badge.displayName = "Badge";
}

var _excluded$f = ["size", "centerContent"],
    _excluded2$5 = ["size"];
var Box$1 = chakra("div");

if (__DEV__) {
  Box$1.displayName = "Box";
}

var Square =
/* @__PURE__ */
forwardRef(function (props, ref) {
  var size = props.size,
      _props$centerContent = props.centerContent,
      centerContent = _props$centerContent === void 0 ? true : _props$centerContent,
      rest = _objectWithoutPropertiesLoose(props, _excluded$f);

  var styles = centerContent ? {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  } : {};
  return (
    /* @__PURE__ */
    React.createElement(Box$1, _extends({
      ref: ref,
      boxSize: size,
      __css: _extends({}, styles, {
        flexShrink: 0,
        flexGrow: 0
      })
    }, rest))
  );
});

if (__DEV__) {
  Square.displayName = "Square";
}

var Circle =
/* @__PURE__ */
forwardRef(function (props, ref) {
  var size = props.size,
      rest = _objectWithoutPropertiesLoose(props, _excluded2$5);

  return (
    /* @__PURE__ */
    React.createElement(Square, _extends({
      size: size,
      ref: ref,
      borderRadius: "9999px"
    }, rest))
  );
});

if (__DEV__) {
  Circle.displayName = "Circle";
}

var Center = chakra("div", {
  baseStyle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }
});

if (__DEV__) {
  Center.displayName = "Center";
}

var _excluded$d = ["className"];
var Code =
/* @__PURE__ */
forwardRef(function (props, ref) {
  var styles = useStyleConfig("Code", props);

  var _omitThemingProps = omitThemingProps(props);

  _omitThemingProps.className;

  var rest = _objectWithoutPropertiesLoose(_omitThemingProps, _excluded$d);

  return (
    /* @__PURE__ */
    React.createElement(chakra.code, _extends({
      ref: ref,
      className: cx("chakra-code", props.className)
    }, rest, {
      __css: _extends({
        display: "inline-block"
      }, styles)
    }))
  );
});

if (__DEV__) {
  Code.displayName = "Code";
}

var _excluded$c = ["className", "centerContent"];
var Container =
/* @__PURE__ */
forwardRef(function (props, ref) {
  var _omitThemingProps = omitThemingProps(props),
      className = _omitThemingProps.className,
      centerContent = _omitThemingProps.centerContent,
      rest = _objectWithoutPropertiesLoose(_omitThemingProps, _excluded$c);

  var styles = useStyleConfig("Container", props);
  return (
    /* @__PURE__ */
    React.createElement(chakra.div, _extends({
      ref: ref,
      className: cx("chakra-container", className)
    }, rest, {
      __css: _extends({}, styles, centerContent && {
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
      })
    }))
  );
});

if (__DEV__) {
  Container.displayName = "Container";
}

var _excluded$b = ["borderLeftWidth", "borderBottomWidth", "borderTopWidth", "borderRightWidth", "borderWidth", "borderStyle", "borderColor"],
    _excluded2$4 = ["className", "orientation", "__css"];
var Divider =
/* @__PURE__ */
forwardRef(function (props, ref) {
  var _useStyleConfig = useStyleConfig("Divider", props),
      borderLeftWidth = _useStyleConfig.borderLeftWidth,
      borderBottomWidth = _useStyleConfig.borderBottomWidth,
      borderTopWidth = _useStyleConfig.borderTopWidth,
      borderRightWidth = _useStyleConfig.borderRightWidth,
      borderWidth = _useStyleConfig.borderWidth,
      borderStyle = _useStyleConfig.borderStyle,
      borderColor = _useStyleConfig.borderColor,
      styles = _objectWithoutPropertiesLoose(_useStyleConfig, _excluded$b);

  var _omitThemingProps = omitThemingProps(props),
      className = _omitThemingProps.className,
      _omitThemingProps$ori = _omitThemingProps.orientation,
      orientation = _omitThemingProps$ori === void 0 ? "horizontal" : _omitThemingProps$ori,
      __css = _omitThemingProps.__css,
      rest = _objectWithoutPropertiesLoose(_omitThemingProps, _excluded2$4);

  var dividerStyles = {
    vertical: {
      borderLeftWidth: borderLeftWidth || borderRightWidth || borderWidth || "1px",
      height: "100%"
    },
    horizontal: {
      borderBottomWidth: borderBottomWidth || borderTopWidth || borderWidth || "1px",
      width: "100%"
    }
  };
  return (
    /* @__PURE__ */
    React.createElement(chakra.hr, _extends({
      ref: ref,
      "aria-orientation": orientation
    }, rest, {
      __css: _extends({}, styles, {
        border: "0",
        borderColor: borderColor,
        borderStyle: borderStyle
      }, dividerStyles[orientation], __css),
      className: cx("chakra-divider", className)
    }))
  );
});

if (__DEV__) {
  Divider.displayName = "Divider";
}

var _excluded$a = ["direction", "align", "justify", "wrap", "basis", "grow", "shrink"];
var Flex =
/* @__PURE__ */
forwardRef(function (props, ref) {
  var direction = props.direction,
      align = props.align,
      justify = props.justify,
      wrap3 = props.wrap,
      basis = props.basis,
      grow = props.grow,
      shrink = props.shrink,
      rest = _objectWithoutPropertiesLoose(props, _excluded$a);

  var styles = {
    display: "flex",
    flexDirection: direction,
    alignItems: align,
    justifyContent: justify,
    flexWrap: wrap3,
    flexBasis: basis,
    flexGrow: grow,
    flexShrink: shrink
  };
  return (
    /* @__PURE__ */
    React.createElement(chakra.div, _extends({
      ref: ref,
      __css: styles
    }, rest))
  );
});

if (__DEV__) {
  Flex.displayName = "Flex";
}

var _excluded$9 = ["area", "templateAreas", "gap", "rowGap", "columnGap", "column", "row", "autoFlow", "autoRows", "templateRows", "autoColumns", "templateColumns"];
var Grid =
/* @__PURE__ */
forwardRef(function (props, ref) {
  var area = props.area,
      templateAreas = props.templateAreas,
      gap = props.gap,
      rowGap = props.rowGap,
      columnGap = props.columnGap,
      column = props.column,
      row = props.row,
      autoFlow = props.autoFlow,
      autoRows = props.autoRows,
      templateRows = props.templateRows,
      autoColumns = props.autoColumns,
      templateColumns = props.templateColumns,
      rest = _objectWithoutPropertiesLoose(props, _excluded$9);

  var styles = {
    display: "grid",
    gridArea: area,
    gridTemplateAreas: templateAreas,
    gridGap: gap,
    gridRowGap: rowGap,
    gridColumnGap: columnGap,
    gridAutoColumns: autoColumns,
    gridColumn: column,
    gridRow: row,
    gridAutoFlow: autoFlow,
    gridAutoRows: autoRows,
    gridTemplateRows: templateRows,
    gridTemplateColumns: templateColumns
  };
  return (
    /* @__PURE__ */
    React.createElement(chakra.div, _extends({
      ref: ref,
      __css: styles
    }, rest))
  );
});

if (__DEV__) {
  Grid.displayName = "Grid";
}

var _excluded$8 = ["className"];
var Heading =
/* @__PURE__ */
forwardRef(function (props, ref) {
  var styles = useStyleConfig("Heading", props);

  var _omitThemingProps = omitThemingProps(props);

  _omitThemingProps.className;

  var rest = _objectWithoutPropertiesLoose(_omitThemingProps, _excluded$8);

  return (
    /* @__PURE__ */
    React.createElement(chakra.h2, _extends({
      ref: ref,
      className: cx("chakra-heading", props.className)
    }, rest, {
      __css: styles
    }))
  );
});

if (__DEV__) {
  Heading.displayName = "Heading";
}

var _excluded$7 = ["className"];
var Kbd =
/* @__PURE__ */
forwardRef(function (props, ref) {
  var styles = useStyleConfig("Kbd", props);

  var _omitThemingProps = omitThemingProps(props),
      className = _omitThemingProps.className,
      rest = _objectWithoutPropertiesLoose(_omitThemingProps, _excluded$7);

  return (
    /* @__PURE__ */
    React.createElement(chakra.kbd, _extends({
      ref: ref,
      className: cx("chakra-kbd", className)
    }, rest, {
      __css: _extends({
        fontFamily: "mono"
      }, styles)
    }))
  );
});

if (__DEV__) {
  Kbd.displayName = "Kbd";
}

var _excluded$6 = ["className", "isExternal"];
var Link =
/* @__PURE__ */
forwardRef(function (props, ref) {
  var styles = useStyleConfig("Link", props);

  var _omitThemingProps = omitThemingProps(props),
      className = _omitThemingProps.className,
      isExternal = _omitThemingProps.isExternal,
      rest = _objectWithoutPropertiesLoose(_omitThemingProps, _excluded$6);

  return (
    /* @__PURE__ */
    React.createElement(chakra.a, _extends({
      target: isExternal ? "_blank" : void 0,
      rel: isExternal ? "noopener" : void 0,
      ref: ref,
      className: cx("chakra-link", className)
    }, rest, {
      __css: styles
    }))
  );
});

if (__DEV__) {
  Link.displayName = "Link";
}

var _excluded$5 = ["children", "styleType", "stylePosition", "spacing"],
    _excluded2$2 = ["as"],
    _excluded3 = ["as"];

var _createContext = createContext({
  name: "StylesContext",
  errorMessage: "useStyles: `styles` is undefined. Seems you forgot to wrap the components in a `<*List />` "
}),
    StylesProvider = _createContext[0],
    useStyles = _createContext[1];

var List =
/* @__PURE__ */
forwardRef(function (props, ref) {
  var _ref;

  var styles = useMultiStyleConfig("List", props);

  var _omitThemingProps = omitThemingProps(props),
      children = _omitThemingProps.children,
      _omitThemingProps$sty = _omitThemingProps.styleType,
      styleType = _omitThemingProps$sty === void 0 ? "none" : _omitThemingProps$sty,
      stylePosition = _omitThemingProps.stylePosition,
      spacing = _omitThemingProps.spacing,
      rest = _objectWithoutPropertiesLoose(_omitThemingProps, _excluded$5);

  var validChildren = getValidChildren(children);
  var selector2 = "& > *:not(style) ~ *:not(style)";
  var spacingStyle = spacing ? (_ref = {}, _ref[selector2] = {
    mt: spacing
  }, _ref) : {};
  return (
    /* @__PURE__ */
    React.createElement(StylesProvider, {
      value: styles
    },
    /* @__PURE__ */
    React.createElement(chakra.ul, _extends({
      ref: ref,
      listStyleType: styleType,
      listStylePosition: stylePosition,
      role: "list",
      __css: _extends({}, styles.container, spacingStyle)
    }, rest), validChildren))
  );
});

if (__DEV__) {
  List.displayName = "List";
}

var OrderedList =
/* @__PURE__ */
forwardRef(function (props, ref) {
  props.as;

  var rest = _objectWithoutPropertiesLoose(props, _excluded2$2);

  return (
    /* @__PURE__ */
    React.createElement(List, _extends({
      ref: ref,
      as: "ol",
      styleType: "decimal",
      marginStart: "1em"
    }, rest))
  );
});

if (__DEV__) {
  OrderedList.displayName = "OrderedList";
}

var UnorderedList =
/* @__PURE__ */
forwardRef(function (props, ref) {
  props.as;

  var rest = _objectWithoutPropertiesLoose(props, _excluded3);

  return (
    /* @__PURE__ */
    React.createElement(List, _extends({
      ref: ref,
      as: "ul",
      styleType: "initial",
      marginStart: "1em"
    }, rest))
  );
});

if (__DEV__) {
  UnorderedList.displayName = "UnorderedList";
}

var ListItem =
/* @__PURE__ */
forwardRef(function (props, ref) {
  var styles = useStyles();
  return (
    /* @__PURE__ */
    React.createElement(chakra.li, _extends({
      ref: ref
    }, props, {
      __css: styles.item
    }))
  );
});

if (__DEV__) {
  ListItem.displayName = "ListItem";
}

var ListIcon =
/* @__PURE__ */
forwardRef(function (props, ref) {
  var styles = useStyles();
  return (
    /* @__PURE__ */
    React.createElement(Icon, _extends({
      ref: ref,
      role: "presentation"
    }, props, {
      __css: styles.icon
    }))
  );
});

if (__DEV__) {
  ListIcon.displayName = "ListIcon";
}

var _excluded$4 = ["columns", "spacingX", "spacingY", "spacing", "minChildWidth"];
var SimpleGrid =
/* @__PURE__ */
forwardRef(function (props, ref) {
  var columns = props.columns,
      spacingX = props.spacingX,
      spacingY = props.spacingY,
      spacing = props.spacing,
      minChildWidth = props.minChildWidth,
      rest = _objectWithoutPropertiesLoose(props, _excluded$4);

  var templateColumns = minChildWidth ? widthToColumns(minChildWidth) : countToColumns(columns);
  return (
    /* @__PURE__ */
    React.createElement(Grid, _extends({
      ref: ref,
      gap: spacing,
      columnGap: spacingX,
      rowGap: spacingY,
      templateColumns: templateColumns
    }, rest))
  );
});

if (__DEV__) {
  SimpleGrid.displayName = "SimpleGrid";
}

function toPx(n) {
  return isNumber(n) ? n + "px" : n;
}

function widthToColumns(width) {
  return mapResponsive(width, function (value) {
    return isNull(value) ? null : "repeat(auto-fit, minmax(" + toPx(value) + ", 1fr))";
  });
}

function countToColumns(count) {
  return mapResponsive(count, function (value) {
    return isNull(value) ? null : "repeat(" + value + ", minmax(0, 1fr))";
  });
}

var Spacer = chakra("div", {
  baseStyle: {
    flex: 1,
    justifySelf: "stretch",
    alignSelf: "stretch"
  }
});

if (__DEV__) {
  Spacer.displayName = "Spacer";
}

var selector = "& > *:not(style) ~ *:not(style)";

function getStackStyles(options) {
  var _ref;

  var spacing = options.spacing,
      direction = options.direction;
  var directionStyles = {
    column: {
      marginTop: spacing,
      marginEnd: 0,
      marginBottom: 0,
      marginStart: 0
    },
    row: {
      marginTop: 0,
      marginEnd: 0,
      marginBottom: 0,
      marginStart: spacing
    },
    "column-reverse": {
      marginTop: 0,
      marginEnd: 0,
      marginBottom: spacing,
      marginStart: 0
    },
    "row-reverse": {
      marginTop: 0,
      marginEnd: spacing,
      marginBottom: 0,
      marginStart: 0
    }
  };
  return _ref = {
    flexDirection: direction
  }, _ref[selector] = mapResponsive(direction, function (value) {
    return directionStyles[value];
  }), _ref;
}

function getDividerStyles(options) {
  var spacing = options.spacing,
      direction = options.direction;
  var dividerStyles = {
    column: {
      my: spacing,
      mx: 0,
      borderLeftWidth: 0,
      borderBottomWidth: "1px"
    },
    "column-reverse": {
      my: spacing,
      mx: 0,
      borderLeftWidth: 0,
      borderBottomWidth: "1px"
    },
    row: {
      mx: spacing,
      my: 0,
      borderLeftWidth: "1px",
      borderBottomWidth: 0
    },
    "row-reverse": {
      mx: spacing,
      my: 0,
      borderLeftWidth: "1px",
      borderBottomWidth: 0
    }
  };
  return {
    "&": mapResponsive(direction, function (value) {
      return dividerStyles[value];
    })
  };
}

var _excluded$3 = ["isInline", "direction", "align", "justify", "spacing", "wrap", "children", "divider", "className", "shouldWrapChildren"];

var StackItem = function StackItem2(props) {
  return (
    /* @__PURE__ */
    React.createElement(chakra.div, _extends({
      className: "chakra-stack__item"
    }, props, {
      __css: _extends({
        display: "inline-block",
        flex: "0 0 auto",
        minWidth: 0
      }, props["__css"])
    }))
  );
};

var Stack =
/* @__PURE__ */
forwardRef(function (props, ref) {
  var _ref;

  var isInline = props.isInline,
      directionProp = props.direction,
      align = props.align,
      justify = props.justify,
      _props$spacing = props.spacing,
      spacing = _props$spacing === void 0 ? "0.5rem" : _props$spacing,
      wrap3 = props.wrap,
      children = props.children,
      divider = props.divider,
      className = props.className,
      shouldWrapChildren = props.shouldWrapChildren,
      rest = _objectWithoutPropertiesLoose(props, _excluded$3);

  var direction = isInline ? "row" : directionProp != null ? directionProp : "column";
  var styles = React.useMemo(function () {
    return getStackStyles({
      direction: direction,
      spacing: spacing
    });
  }, [direction, spacing]);
  var dividerStyle = React.useMemo(function () {
    return getDividerStyles({
      spacing: spacing,
      direction: direction
    });
  }, [spacing, direction]);
  var hasDivider = !!divider;
  var shouldUseChildren = !shouldWrapChildren && !hasDivider;
  var validChildren = getValidChildren(children);
  var clones = shouldUseChildren ? validChildren : validChildren.map(function (child, index) {
    var key = typeof child.key !== "undefined" ? child.key : index;
    var isLast = index + 1 === validChildren.length;
    var wrappedChild =
    /* @__PURE__ */
    React.createElement(StackItem, {
      key: key
    }, child);

    var _child = shouldWrapChildren ? wrappedChild : child;

    if (!hasDivider) return _child;
    var clonedDivider =
    /* @__PURE__ */
    React.cloneElement(divider, {
      __css: dividerStyle
    });

    var _divider = isLast ? null : clonedDivider;

    return (
      /* @__PURE__ */
      React.createElement(React.Fragment, {
        key: key
      }, _child, _divider)
    );
  });

  var _className = cx("chakra-stack", className);

  return (
    /* @__PURE__ */
    React.createElement(chakra.div, _extends({
      ref: ref,
      display: "flex",
      alignItems: align,
      justifyContent: justify,
      flexDirection: styles.flexDirection,
      flexWrap: wrap3,
      className: _className,
      __css: hasDivider ? {} : (_ref = {}, _ref[selector] = styles[selector], _ref)
    }, rest), clones)
  );
});

if (__DEV__) {
  Stack.displayName = "Stack";
}

var HStack =
/* @__PURE__ */
forwardRef(function (props, ref) {
  return (
    /* @__PURE__ */
    React.createElement(Stack, _extends({
      align: "center"
    }, props, {
      direction: "row",
      ref: ref
    }))
  );
});

if (__DEV__) {
  HStack.displayName = "HStack";
}

var VStack =
/* @__PURE__ */
forwardRef(function (props, ref) {
  return (
    /* @__PURE__ */
    React.createElement(Stack, _extends({
      align: "center"
    }, props, {
      direction: "column",
      ref: ref
    }))
  );
});

if (__DEV__) {
  VStack.displayName = "VStack";
}

var _excluded$2 = ["className", "align", "decoration", "casing"];
var Text =
/* @__PURE__ */
forwardRef(function (props, ref) {
  var styles = useStyleConfig("Text", props);

  var _omitThemingProps = omitThemingProps(props);

  _omitThemingProps.className;
  _omitThemingProps.align;
  _omitThemingProps.decoration;
  _omitThemingProps.casing;

  var rest = _objectWithoutPropertiesLoose(_omitThemingProps, _excluded$2);

  var aliasedProps = filterUndefined({
    textAlign: props.align,
    textDecoration: props.decoration,
    textTransform: props.casing
  });
  return (
    /* @__PURE__ */
    React.createElement(chakra.p, _extends({
      ref: ref,
      className: cx("chakra-text", props.className)
    }, aliasedProps, rest, {
      __css: styles
    }))
  );
});

if (__DEV__) {
  Text.displayName = "Text";
}

var _excluded$1 = ["spacing", "spacingX", "spacingY", "children", "justify", "direction", "align", "className", "shouldWrapChildren"],
    _excluded2$1 = ["className"];
var Wrap =
/* @__PURE__ */
forwardRef(function (props, ref) {
  var _props$spacing = props.spacing,
      spacing = _props$spacing === void 0 ? "0.5rem" : _props$spacing,
      spacingX = props.spacingX,
      spacingY = props.spacingY,
      children = props.children,
      justify = props.justify,
      direction = props.direction,
      align = props.align,
      className = props.className,
      shouldWrapChildren = props.shouldWrapChildren,
      rest = _objectWithoutPropertiesLoose(props, _excluded$1);

  var styles = React.useMemo(function () {
    var _spacingX$spacingY = {
      spacingX: spacingX,
      spacingY: spacingY
    },
        _spacingX$spacingY$sp = _spacingX$spacingY.spacingX,
        x = _spacingX$spacingY$sp === void 0 ? spacing : _spacingX$spacingY$sp,
        _spacingX$spacingY$sp2 = _spacingX$spacingY.spacingY,
        y = _spacingX$spacingY$sp2 === void 0 ? spacing : _spacingX$spacingY$sp2;
    return {
      "--chakra-wrap-x-spacing": function chakraWrapXSpacing(theme) {
        return mapResponsive(x, function (value) {
          return tokenToCSSVar("space", value)(theme);
        });
      },
      "--chakra-wrap-y-spacing": function chakraWrapYSpacing(theme) {
        return mapResponsive(y, function (value) {
          return tokenToCSSVar("space", value)(theme);
        });
      },
      "--wrap-x-spacing": "calc(var(--chakra-wrap-x-spacing) / 2)",
      "--wrap-y-spacing": "calc(var(--chakra-wrap-y-spacing) / 2)",
      display: "flex",
      flexWrap: "wrap",
      justifyContent: justify,
      alignItems: align,
      flexDirection: direction,
      listStyleType: "none",
      padding: "0",
      margin: "calc(var(--wrap-y-spacing) * -1) calc(var(--wrap-x-spacing) * -1)",
      "& > *:not(style)": {
        margin: "var(--wrap-y-spacing) var(--wrap-x-spacing)"
      }
    };
  }, [spacing, spacingX, spacingY, justify, align, direction]);
  var childrenToRender = shouldWrapChildren ? React.Children.map(children, function (child, index) {
    return (
      /* @__PURE__ */
      React.createElement(WrapItem, {
        key: index
      }, child)
    );
  }) : children;
  return (
    /* @__PURE__ */
    React.createElement(chakra.div, _extends({
      ref: ref,
      className: cx("chakra-wrap", className)
    }, rest),
    /* @__PURE__ */
    React.createElement(chakra.ul, {
      className: "chakra-wrap__list",
      __css: styles
    }, childrenToRender))
  );
});

if (__DEV__) {
  Wrap.displayName = "Wrap";
}

var WrapItem =
/* @__PURE__ */
forwardRef(function (props, ref) {
  var className = props.className,
      rest = _objectWithoutPropertiesLoose(props, _excluded2$1);

  return (
    /* @__PURE__ */
    React.createElement(chakra.li, _extends({
      ref: ref,
      __css: {
        display: "flex",
        alignItems: "flex-start"
      },
      className: cx("chakra-wrap__listitem", className)
    }, rest))
  );
});

if (__DEV__) {
  WrapItem.displayName = "WrapItem";
}

var MotionBox = motion(Box$1);

function InnerTooltip(_ref3) {
  var label = _ref3.label,
      percent = _ref3.percent,
      isActive = _ref3.isActive,
      keyString = _ref3.keyString,
      rest = _objectWithoutProperties(_ref3, ["label", "percent", "isActive", "keyString"]);

  var formattedPercent = percent * 100 >= 1 ? (percent * 100).toFixed(1) : (percent * 100).toFixed(2);
  return React__default.createElement(AnimatePresence, {
    key: keyString
  }, isActive && React__default.createElement(MotionBox, _objectSpread({
    width: "28",
    height: "8",
    textAlign: "center",
    padding: "3",
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    transition: {
      opacity: {
        type: "tween",
        "default": {
          duration: 0.4
        }
      }
    },
    exit: {
      opacity: 0
    }
  }, rest), React__default.createElement(Text$1, {
    lineHeight: "xl",
    fontWeight: "bold",
    fontSize: "xs"
  }, formattedPercent, "%"), React__default.createElement(Text$1, {
    lineHeight: "xl",
    fontSize: "xs"
  }, label)));
}

function ActiveShape(props) {
  var propsOuterRadius = props.outerRadius,
      label = props.label,
      percent = props.percent,
      onLeaveAnimationFinished = props.onLeaveAnimationFinished,
      isActive = props.isActive,
      _props$animationOuter = props.animationOuterRadiusOffset,
      animationOuterRadiusOffset = _props$animationOuter === void 0 ? 5 : _props$animationOuter,
      _props$animationDurat = props.animationDuration,
      animationDuration = _props$animationDurat === void 0 ? 0.4 : _props$animationDurat,
      name = props.name,
      cx3 = props.cx,
      cy = props.cy;
  var defaultOuterRadius = propsOuterRadius || 0;
  var animateTo = isActive ? defaultOuterRadius + animationOuterRadiusOffset : defaultOuterRadius;

  var onAnimationComplete = function onAnimationComplete() {
    if (!isActive) {
      onLeaveAnimationFinished(name);
    }
  };

  var outerRadius = useAnimatableProperty(defaultOuterRadius, animateTo, {
    duration: animationDuration,
    onComplete: onAnimationComplete
  }, true);
  return React__default.createElement(React__default.Fragment, null, React__default.createElement("foreignObject", {
    x: cx3 - 56,
    y: cy - 32,
    dy: 0,
    width: 120,
    height: 64
  }, React__default.createElement(InnerTooltip, {
    label: label,
    percent: percent,
    isActive: isActive,
    keyString: "".concat(cx3, "-").concat(cy, "-innertooltip")
  })), React__default.createElement(Sector, _objectSpread({}, props, {
    ref: void 0,
    outerRadius: defaultOuterRadius
  })), React__default.createElement(Sector, _objectSpread({}, props, {
    ref: void 0,
    outerRadius: outerRadius
  })));
}

function EmptyStatePie(_ref4) {
  var innerRadius = _ref4.innerRadius,
      outerRadius = _ref4.outerRadius;
  var borderSize = outerRadius - innerRadius;
  return React__default.createElement(Box$1, {
    width: "100%",
    height: "100%",
    display: "flex"
  }, React__default.createElement(Box$1, {
    boxSizing: "initial",
    border: "".concat(borderSize, "px solid #A6CFE2"),
    borderColor: "gray-300",
    borderRadius: "180px",
    height: "".concat(innerRadius * 2 + 10, "px"),
    width: "".concat(innerRadius * 2 + 10, "px"),
    padding: "2",
    margin: "auto"
  }, React__default.createElement(Text, {
    textAlign: "center",
    fontSize: "xs",
    mt: "7",
    color: "grey"
  }, "Not enough data collected")));
}

var Box = forwardRef$1(function BaseBox(_ref5, ref) {
  var children = _ref5.children,
      rest = _objectWithoutProperties(_ref5, ["children"]);

  return (
    /* @__PURE__ */
    jsx(Box$2, _objectSpread({
      ref: ref
    }, rest, {
      children: children
    }))
  );
});
var WeightedColors = ["success", "warning", "error", "brandHue", "blackAlpha", "whiteAlpha", "gray", "red", "blue", "purple", "teal", "green", "orange", "yellow", "cyan", "pink", "light_blue", "forest_green", "light_orange", "fuschia"];
var Colors = {
  transparent: "transparent",
  brand: "#f15d4b",
  info: "#63B3ED",
  black: "#444",
  trueBlack: "#000",
  white: "#fff",
  gradients: {
    fuschiaOrange: "linear-gradient(89.13deg, #FD65A8 1.21%, #FFA24D 98.74%)",
    fuschiaShades: "linear-gradient(93.34deg, #FD65A8 0.19%, #FD65A8 48.01%, #F295A8 100%)",
    orangeFuschia: "linear-gradient(89.69deg, #F47D6F 0.48%, #FD65A8 99.58%)",
    orangeShades: "linear-gradient(87.97deg, #F47D6F 2.65%, #FFA24D 97.3%)",
    sunset: "linear-gradient(93.16deg, #AD5BD6 0.18%, #FD65A8 51.58%, #FFA24D 99.73%)",
    tealBlue: "linear-gradient(89.41deg, #33B8A9 21.25%, #3399FF 99.16%)"
  },
  blackAlpha: {
    50: "rgba(0, 0, 0, 0.04)",
    100: "rgba(0, 0, 0, 0.06)",
    200: "rgba(0, 0, 0, 0.08)",
    300: "rgba(0, 0, 0, 0.16)",
    400: "rgba(0, 0, 0, 0.24)",
    500: "rgba(0, 0, 0, 0.36)",
    600: "rgba(0, 0, 0, 0.48)",
    700: "rgba(0, 0, 0, 0.64)",
    800: "rgba(0, 0, 0, 0.80)",
    900: "rgba(0, 0, 0, 0.92)"
  },
  whiteAlpha: {
    50: "rgba(255, 255, 255, 0.04)",
    100: "rgba(255, 255, 255, 0.06)",
    200: "rgba(255, 255, 255, 0.08)",
    300: "rgba(255, 255, 255, 0.16)",
    400: "rgba(255, 255, 255, 0.24)",
    500: "rgba(255, 255, 255, 0.36)",
    600: "rgba(255, 255, 255, 0.48)",
    700: "rgba(255, 255, 255, 0.64)",
    800: "rgba(255, 255, 255, 0.80)",
    900: "rgba(255, 255, 255, 0.92)"
  },
  pink: {
    50: "#FFF5F7",
    100: "#FED7E2",
    200: "#FBB6CE",
    300: "#F687B3",
    400: "#ED64A6",
    500: "#D53F8C",
    600: "#B83280",
    700: "#97266D",
    800: "#702459",
    900: "#521B41"
  },
  success: {
    50: "#eaf4ec",
    100: "#e6f6f0",
    200: "#b3e5d3",
    300: "#80d4b5",
    400: "#4dc297",
    500: "#00a86b",
    600: "#008656",
    700: "#006540",
    800: "#00432b",
    900: "#002215"
  },
  warning: {
    50: "#f8f4e6",
    100: "#fff6e6",
    200: "#ffe5b3",
    300: "#ffd380",
    400: "#ffc14d",
    500: "#ffa700",
    600: "#e69600",
    700: "#b37500",
    800: "#805400",
    900: "#4c3200"
  },
  error: {
    50: "#fcecea",
    100: "#ffe9e7",
    200: "#ffbeb8",
    300: "#ff9389",
    400: "#fe6859",
    500: "#fe2712",
    600: "#cb1f0e",
    700: "#98170b",
    800: "#661007",
    900: "#330804"
  },
  brandHue: {
    50: "#f7d1cc",
    100: "#fbb6ae",
    200: "#fda69c",
    300: "#f58173",
    400: "#f56b5a",
    500: "#f15d4b",
    600: "#d94231",
    700: "#df3925",
    800: "#b92210",
    900: "#8d1204"
  },
  gray: {
    50: "#f2f4f5",
    100: "#eeeff1",
    200: "#dde0e2",
    300: "#87919a",
    400: "#65727d",
    500: "#54626f",
    600: "#434e59",
    700: "#323b43",
    800: "#22272c",
    900: "#111416"
  },
  red: {
    50: "#FFECEE",
    100: "#fceaee",
    200: "#f7bfcb",
    300: "#f295a8",
    400: "#ed6b85",
    500: "#e52b50",
    600: "#ce2748",
    700: "#a01e38",
    800: "#731628",
    900: "#450d18"
  },
  blue: {
    50: "#f4f9ff",
    100: "#e6f2ff",
    200: "#99ccff",
    300: "#66b2ff",
    400: "#3399ff",
    500: "#0072e6",
    600: "#0059b3",
    700: "#004080",
    800: "#00264c",
    900: "#000d19"
  },
  yellow: {
    50: "#fffdf2",
    100: "#fffbe6",
    200: "#ffed99",
    300: "#ffe566",
    400: "#ffdc33",
    500: "#ffd300",
    600: "#e6be00",
    700: "#b39400",
    800: "#806a00",
    900: "#4c3f00"
  },
  light_blue: {
    50: "#dcf8ff",
    100: "#b2e5fe",
    200: "#85d2f6",
    300: "#59c0f1",
    400: "#2daeec",
    500: "#1395d2",
    600: "#0474a4",
    700: "#005377",
    800: "#00334a",
    900: "#00131d"
  },
  cyan: {
    50: "#e8fafa",
    100: "#e6f8fd",
    200: "#b3e9f9",
    300: "#80dbf5",
    400: "#4dcdf1",
    500: "#00b7eb",
    600: "#0092bc",
    700: "#006e8d",
    800: "#00495e",
    900: "#00252f"
  },
  purple: {
    50: "#faf3fe",
    100: "#f5ebfa",
    200: "#d6adeb",
    300: "#c284e0",
    400: "#ad5bd6",
    500: "#9932cc",
    600: "#7a28a3",
    700: "#5c1e7a",
    800: "#3d1452",
    900: "#1f0a29"
  },
  teal: {
    50: "#f0fbfb",
    100: "#e6f6f4",
    200: "#99dbd4",
    300: "#66cabe",
    400: "#33b8a9",
    500: "#00a693",
    600: "#009584",
    700: "#007467",
    800: "#00534a",
    900: "#00322c"
  },
  forest_green: {
    50: "#e2fbef",
    100: "#c1ecd6",
    200: "#9ddfbc",
    300: "#79d1a2",
    400: "#55c489",
    500: "#3baa6f",
    600: "#2c8455",
    700: "#1d5f3d",
    800: "#0d3a23",
    900: "#001506"
  },
  green: {
    50: "#f6faec",
    100: "#f0f7eb",
    200: "#d1e7c2",
    300: "#b3d899",
    400: "#94c870",
    500: "#66b032",
    600: "#528d28",
    700: "#3d6a1e",
    800: "#294614",
    900: "#14230a"
  },
  orange: {
    50: "#fbf2ea",
    100: "#fff2e6",
    200: "#ffd7b3",
    300: "#ffbd80",
    400: "#ffa24d",
    500: "#ff7a00",
    600: "#e66e00",
    700: "#b35500",
    800: "#803d00",
    900: "#4c2500"
  },
  light_orange: {
    50: "#fff3dc",
    100: "#fddfb1",
    200: "#faca83",
    300: "#f6b555",
    400: "#f3a025",
    500: "#da870c",
    600: "#a96906",
    700: "#7a4b02",
    800: "#4b2c00",
    900: "#1d0e00"
  },
  fuschia: {
    50: "#fff4f9",
    100: "#ffecf4",
    200: "#feb2d3",
    300: "#fe8cbe",
    400: "#fd65a8",
    500: "#fd3f92",
    600: "#ca3275",
    700: "#982658",
    800: "#65193a",
    900: "#330d1d"
  }
};
var hexCharacters = "a-f\\d";
var match3or4Hex = "#?[".concat(hexCharacters, "]{3}[").concat(hexCharacters, "]?");
var match6or8Hex = "#?[".concat(hexCharacters, "]{6}([").concat(hexCharacters, "]{2})?");
var nonHexChars = new RegExp("[^#".concat(hexCharacters, "]"), "gi");
var validHexSize = new RegExp("^".concat(match3or4Hex, "$|^").concat(match6or8Hex, "$"), "i");

var hexRgb = function hexRgb(hex) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof hex !== "string" || nonHexChars.test(hex) || !validHexSize.test(hex)) {
    throw new TypeError("Expected a valid hex string");
  }

  hex = hex.replace(/^#/, "");
  var alphaFromHex = 1;

  if (hex.length === 8) {
    alphaFromHex = Number.parseInt(hex.slice(6, 8), 16) / 255;
    hex = hex.slice(0, 6);
  }

  if (hex.length === 4) {
    alphaFromHex = Number.parseInt(hex.slice(3, 4).repeat(2), 16) / 255;
    hex = hex.slice(0, 3);
  }

  if (hex.length === 3) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }

  var number = Number.parseInt(hex, 16);
  var red = number >> 16;
  var green = number >> 8 & 255;
  var blue = number & 255;
  var alpha = typeof options.alpha === "number" ? options.alpha : alphaFromHex;

  if (options.format === "array") {
    return [red, green, blue, alpha];
  }

  if (options.format === "css") {
    var alphaString = alpha === 1 ? "" : " / ".concat(Number((alpha * 100).toFixed(2)), "%");
    return "rgb(".concat(red, " ").concat(green, " ").concat(blue).concat(alphaString, ")");
  }

  return {
    red: red,
    green: green,
    blue: blue,
    alpha: alpha
  };
};

var hexRgb$1 =
/* @__PURE__ */
getDefaultExportFromCjs(hexRgb);
var font = "Inter, system-ui, Roboto, Helvetica, Arial, sans-serif";
var TapTheme = {
  colors: Colors,
  fn: {
    rgba: function rgba(hex, alpha) {
      return hexRgb$1(hex, {
        alpha: alpha,
        format: "css"
      });
    },
    rgb_values: function rgb_values(hex) {
      return hexRgb$1(hex, {
        format: "array"
      }).slice(0, -1).join(", ");
    }
  },
  fonts: {
    primary: font,
    secondary: font,
    heading: font,
    body: font
  },
  fontSizes: {
    xs: "0.75rem",
    sm: "0.925rem",
    md: "1rem",
    lg: "1.125rem",
    xl: "1.25rem",
    "2xl": "1.5rem",
    "3xl": "1.875rem",
    "4xl": "2.25rem",
    "5xl": "3rem",
    "6xl": "3.75rem",
    "7xl": "4.5rem",
    "8xl": "6rem",
    "9xl": "8rem"
  },
  fontWeights: {
    hairline: 100,
    thin: 200,
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
    black: 900
  },
  lineHeights: {
    normal: "normal",
    none: 1,
    shorter: 1.25,
    "short": 1.375,
    base: 1.5,
    tall: 1.625,
    taller: "2",
    "3": ".75rem",
    "4": "1rem",
    "5": "1.25rem",
    "6": "1.5rem",
    "7": "1.75rem",
    "8": "2rem",
    "9": "2.25rem",
    "10": "2.5rem"
  },
  letterSpacings: {
    tighter: "-0.05em",
    tight: "-0.025em",
    normal: "0",
    wide: "0.025em",
    wider: "0.05em",
    widest: "0.1em"
  },
  radii: {
    none: "0",
    sm: "0.125rem",
    base: "0.25rem",
    md: "0.375rem",
    lg: "0.5rem",
    xl: "0.75rem",
    "2xl": "1rem",
    "3xl": "1.5rem",
    full: "9999px"
  }
};
WeightedColors.reduce(function (acc, colorKey) {
  return _objectSpread({}, acc, _defineProperty({}, colorKey, Object.values(TapTheme.colors[colorKey])));
}, {});

function Legend(props) {
  var data = props.data,
      currentActiveIndex = props.currentActiveIndex,
      onItemHover = props.onItemHover,
      onItemLeave = props.onItemLeave,
      rest = _objectWithoutProperties(props, ["data", "currentActiveIndex", "onItemHover", "onItemLeave"]);

  var opacity = useAnimatableProperty(0, 1, {
    duration: 1
  }, true);
  return React__default.createElement(Box, _objectSpread({
    as: "ul",
    width: "auto",
    textAlign: "left",
    __css: {
      opacity: opacity
    }
  }, rest), (data || []).map(function (entry, index) {
    return React__default.createElement(Flex$1, {
      as: "li",
      key: "item-".concat(index),
      alignItems: "center",
      mb: "1",
      padding: "0.5",
      pl: "1",
      onMouseEnter: function onMouseEnter() {
        if (onItemHover) {
          onItemHover(data[index], index);
        }
      },
      onMouseLeave: function onMouseLeave() {
        if (onItemLeave) {
          onItemLeave(data[index], index);
        }
      },
      bgColor: index === currentActiveIndex ? TapTheme.colors.gray[100] : void 0
    }, React__default.createElement(Circle$1, {
      display: "block",
      backgroundColor: entry.color,
      size: "3.5"
    }), React__default.createElement(Text$1, {
      as: "p",
      ml: "2",
      fontSize: "xs",
      whiteSpace: "nowrap"
    }, entry.label));
  }));
}

function PieChart(_ref6) {
  var data = _ref6.data,
      _ref6$outerRadius = _ref6.outerRadius,
      outerRadius = _ref6$outerRadius === void 0 ? 60 : _ref6$outerRadius,
      _ref6$innerRadius = _ref6.innerRadius,
      innerRadius = _ref6$innerRadius === void 0 ? 40 : _ref6$innerRadius,
      _ref6$displayLegend = _ref6.displayLegend,
      displayLegend = _ref6$displayLegend === void 0 ? false : _ref6$displayLegend,
      onSectorHover = _ref6.onSectorHover,
      onSectorLeave = _ref6.onSectorLeave;

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      currentActiveIndex = _useState4[0],
      setActiveIndex = _useState4[1];

  var _useReducer = useReducer(activeIndexesReducer, {}),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      activeIndexes = _useReducer2[0],
      dispatch = _useReducer2[1];

  var onPieEnter = function onPieEnter(_, pieIndex) {
    if (onSectorHover) {
      onSectorHover(data[pieIndex], pieIndex);
    }

    setActiveIndex(pieIndex);
    dispatch(addIndexAction(data[pieIndex].name, pieIndex));
  };

  var onPieLeave = function onPieLeave() {
    if (onSectorLeave) {
      onSectorLeave(currentActiveIndex);
    }

    setActiveIndex(void 0);
  };

  var onShapeLeaveAnimationFinished = function onShapeLeaveAnimationFinished(shapeIndexLabel) {
    dispatch(removeIndexAction(shapeIndexLabel));
  };

  var renderActiveShape = function renderActiveShape(props) {
    var isActive = currentActiveIndex !== void 0 ? props.name === data[currentActiveIndex].name : false;
    return React__default.createElement(ActiveShape, _objectSpread({}, props, {
      isActive: isActive,
      onLeaveAnimationFinished: onShapeLeaveAnimationFinished
    }));
  };

  var isEmptyState = data.length === 0;
  return React__default.createElement(React__default.Fragment, null, isEmptyState && React__default.createElement(EmptyStatePie, {
    innerRadius: innerRadius,
    outerRadius: outerRadius
  }), !isEmptyState && React__default.createElement(Flex$1, {
    width: "100%",
    height: "100%",
    alignItems: "center",
    justifyContent: "space-between"
  }, React__default.createElement(ResponsiveContainer, {
    width: "100%",
    height: "100%"
  }, React__default.createElement(PieChart$1, null, React__default.createElement(Pie, {
    activeIndex: Object.values(activeIndexes),
    activeShape: renderActiveShape,
    data: data,
    dataKey: "value",
    nameKey: "name",
    innerRadius: innerRadius,
    outerRadius: outerRadius,
    onMouseEnter: onPieEnter,
    onMouseLeave: onPieLeave
  }, data.map(function (dataEntry) {
    return React__default.createElement(Cell, {
      key: "cell-".concat(dataEntry.name),
      fill: dataEntry.color
    });
  })))), displayLegend && React__default.createElement(Legend, {
    data: data,
    currentActiveIndex: currentActiveIndex,
    ml: "4",
    onItemHover: onPieEnter,
    onItemLeave: onPieLeave
  })));
}

var clickKeyStateColors = {
  abandoned: TapTheme.colors.red[200],
  quality_term: TapTheme.colors.gray[600],
  over_quota: TapTheme.colors.gray[300],
  disqualified: TapTheme.colors.blue[500],
  complete: TapTheme.colors.green[300],
  in_flight: TapTheme.colors.light_orange[300]
};
var clickKeyStateLabels = {
  abandoned: "Abandoned",
  quality_term: "Quality term",
  over_quota: "Over quota",
  disqualified: "Disqualified",
  complete: "Complete",
  in_flight: "In flight"
};

var clickKeyStateToFullData = function clickKeyStateToFullData(clickKeyStateValues) {
  return Object.keys(clickKeyStateValues).map(function (cks) {
    var value = clickKeyStateValues[cks];
    var color2 = clickKeyStateColors[cks];
    var label = clickKeyStateLabels[cks];
    var name = cks;
    return {
      value: value,
      color: color2,
      name: name,
      label: label
    };
  });
};

function lineAreaDataToChartData(_ref7) {
  var dataNames = _ref7.dataNames,
      linearAreas = _ref7.linearAreas,
      data = _ref7.data,
      lineColors = _ref7.lineColors,
      lineStrokeDashArray = _ref7.lineStrokeDashArray;
  var linearAreasData = linearAreas.map(function (_ref8) {
    var _ref8$keys = _slicedToArray(_ref8.keys, 2),
        upperDataKey = _ref8$keys[0],
        lowerDataKey = _ref8$keys[1],
        color2 = _ref8.color;

    var areaData = data.map(function (dataPoint) {
      return [dataPoint[upperDataKey], dataPoint[lowerDataKey]];
    });
    return {
      data: areaData,
      color: color2
    };
  });
  return {
    dataNames: dataNames,
    data: data,
    areas: _toConsumableArray(linearAreasData),
    lineColors: lineColors,
    lineStrokeDashArray: lineStrokeDashArray
  };
}

function ChartTooltip(_ref9) {
  var _ref9$isActive = _ref9.isActive,
      isActive = _ref9$isActive === void 0 ? true : _ref9$isActive,
      keyString = _ref9.keyString,
      children = _ref9.children,
      rest = _objectWithoutProperties(_ref9, ["isActive", "keyString", "children"]);

  return React__default.createElement(AnimatePresence, {
    key: keyString
  }, isActive === true && React__default.createElement(MotionBox, _objectSpread({
    minWidth: "28",
    maxWidth: "32",
    border: "1px solid",
    borderColor: TapTheme.colors.gray["500"],
    padding: "2",
    backgroundColor: TapTheme.colors["white"],
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    transition: {
      opacity: {
        type: "tween",
        "default": {
          duration: 0.8
        }
      }
    },
    exit: {
      opacity: 0
    },
    boxShadow: "2px 2px 2px ".concat(TapTheme.fn.rgba(TapTheme.colors.black, 0.5))
  }, rest), children));
}

function ChartTooltipData(_ref10) {
  var value = _ref10.value,
      label = _ref10.label,
      color2 = _ref10.color,
      boxProps = _objectWithoutProperties(_ref10, ["value", "label", "color"]);

  return React__default.createElement(Box$2, _objectSpread({}, boxProps), label && React__default.createElement(Text$1, {
    fontSize: "xs",
    lineHeight: "shorter",
    textTransform: "capitalize"
  }, label), React__default.createElement(Text$1, {
    fontSize: "xs",
    lineHeight: "none",
    display: "flex",
    alignItems: "center",
    fontWeight: "bold"
  }, React__default.createElement(Box$2, {
    as: "span",
    backgroundColor: color2,
    mr: "1",
    display: "inline-block",
    width: "3",
    height: "3",
    border: "1px solid"
  }), value));
}

function CustomTooltip(props) {
  var _a;

  return React__default.createElement(ChartTooltip, {
    isActive: !!props.active
  }, (_a = props.payload) == null ? void 0 : _a.reduce(function (acc, payloadItem) {
    if (payloadItem.unit) {
      acc.push(React__default.createElement(ChartTooltipData, {
        key: "".concat(payloadItem.name, "-").concat(payloadItem.value),
        mb: 1,
        label: payloadItem.name,
        value: "".concat(payloadItem.value, " ").concat(payloadItem.unit),
        color: payloadItem.color
      }));
    }

    return acc;
  }, []));
}

function MultiLineAreaChart(_ref11) {
  var _ref11$width = _ref11.width,
      width = _ref11$width === void 0 ? "100%" : _ref11$width,
      _ref11$height = _ref11.height,
      height = _ref11$height === void 0 ? "100%" : _ref11$height,
      lineAreaData = _objectWithoutProperties(_ref11, ["width", "height"]);

  var indexes = lineAreaData.data.map(function (_dataPoint, index) {
    return index;
  });
  var chartData = lineAreaDataToChartData(lineAreaData);
  var skipInTooltip = lineAreaData.skipInTooltip || [];
  return React__default.createElement(ResponsiveContainer, {
    width: width,
    height: height
  }, React__default.createElement(ComposedChart, {
    data: indexes
  }, React__default.createElement(CartesianGrid, {
    stroke: "#f5f5f5"
  }), React__default.createElement(XAxis, {
    dataKey: function dataKey(index) {
      return chartData.dataNames[index];
    }
  }), React__default.createElement(YAxis, {
    width: 40
  }), chartData.areas.map(function (areaData, areaIndex) {
    return React__default.createElement(Area, {
      key: "area-".concat(areaIndex),
      dataKey: function dataKey(index) {
        return areaData.data[index];
      },
      fill: areaData.color
    });
  }), Object.keys(chartData.lineColors).map(function (dataKeyName) {
    var _a;

    return React__default.createElement(Line, {
      key: "line-".concat(dataKeyName),
      dataKey: function dataKey(index) {
        return chartData.data[index][dataKeyName];
      },
      name: dataKeyName,
      stroke: chartData.lineColors[dataKeyName] || "black",
      strokeDasharray: (_a = chartData.lineStrokeDashArray) == null ? void 0 : _a[dataKeyName],
      unit: skipInTooltip.includes(dataKeyName) ? void 0 : lineAreaData.unit
    });
  }), React__default.createElement(Tooltip, {
    content: React__default.createElement(CustomTooltip, null)
  })));
}

function acumDataToChartData(data) {
  return data.map(function (dataItem) {
    var acumulated = dataItem.acumulated,
        objective = dataItem.objective;
    var total = Math.max(acumulated, objective);
    var objectiveDataPoint = objective > acumulated ? objective - acumulated : 0;
    return _objectSpread({}, dataItem, {
      total: total,
      objectiveDataPoint: objectiveDataPoint
    });
  });
}

function RoundedRectShape(_ref12) {
  var fill = _ref12.fill,
      x = _ref12.x,
      y = _ref12.y,
      width = _ref12.width,
      height = _ref12.height;
  var radiusControl = 8;
  return React__default.createElement("path", {
    d: "\n        M".concat(x, ",").concat(y, "\n        h").concat(width - radiusControl, "\n        q").concat(radiusControl, ",0,").concat(radiusControl, ",").concat(height / 2, "\n        q0,").concat(height / 2, ",-").concat(radiusControl, ",").concat(height / 2, "\n        h").concat((width - radiusControl) * -1, "\n      "),
    fill: fill
  });
}

function Rect(_ref13) {
  var fill = _ref13.fill,
      x = _ref13.x,
      y = _ref13.y,
      width = _ref13.width,
      height = _ref13.height;
  return React__default.createElement("rect", {
    x: x,
    y: y,
    width: width,
    height: height,
    fill: fill
  });
}

function AcumBarChart(_ref14) {
  var data = _ref14.data,
      _ref14$barSize = _ref14.barSize,
      barSize = _ref14$barSize === void 0 ? 15 : _ref14$barSize,
      _ref14$objectiveColor = _ref14.objectiveColor,
      objectiveColor = _ref14$objectiveColor === void 0 ? "blue" : _ref14$objectiveColor,
      _ref14$acumulatedColo = _ref14.acumulatedColor,
      acumulatedColor = _ref14$acumulatedColo === void 0 ? "green" : _ref14$acumulatedColo,
      _ref14$barCategoryGap = _ref14.barCategoryGap,
      barCategoryGap = _ref14$barCategoryGap === void 0 ? 20 : _ref14$barCategoryGap,
      unit = _ref14.unit,
      _ref14$width = _ref14.width,
      width = _ref14$width === void 0 ? "100%" : _ref14$width;
  var xAxisHeight = 25;
  var containerHeight = (barSize + barCategoryGap * 2) * data.length;
  var chartData = useMemo(function () {
    return acumDataToChartData(data);
  }, [data]);
  var chartDataByName = useMemo(function () {
    return chartData.reduce(function (acc, dataItem) {
      return _objectSpread({}, acc, _defineProperty({}, dataItem.name, dataItem));
    }, {});
  }, [chartData]);

  function renderTooltip(props) {
    var label = props.label,
        active2 = props.active;
    var itemData = chartDataByName[label];
    return React__default.createElement(ChartTooltip, {
      isActive: !!active2
    }, itemData && React__default.createElement(ChartTooltipData, {
      mb: 1,
      label: "Objective",
      value: "".concat(itemData["objective"], " ").concat(unit || ""),
      color: objectiveColor
    }), itemData && React__default.createElement(ChartTooltipData, {
      mb: 1,
      label: "Acumulated",
      value: "".concat(itemData["acumulated"], " ").concat(unit || ""),
      color: acumulatedColor
    }));
  }

  var renderAcumulatedShape = function renderAcumulatedShape(props) {
    if (props.objective <= props.acumulated) {
      return React__default.createElement(RoundedRectShape, _objectSpread({}, props));
    }

    return React__default.createElement(Rect, _objectSpread({}, props));
  };

  var renderObjectiveShape = function renderObjectiveShape(props) {
    if (props.objective <= props.acumulated) {
      return React__default.createElement(Rect, _objectSpread({}, props, {
        width: 0
      }));
    }

    return React__default.createElement(RoundedRectShape, _objectSpread({}, props));
  };

  return React__default.createElement(ResponsiveContainer, {
    width: width,
    height: containerHeight
  }, React__default.createElement(BarChart, {
    data: chartData,
    layout: "vertical",
    barSize: barSize,
    barCategoryGap: barCategoryGap
  }, React__default.createElement(CartesianGrid, null), React__default.createElement(XAxis, {
    type: "number",
    width: xAxisHeight
  }), React__default.createElement(YAxis, {
    dataKey: "name",
    type: "category",
    scale: "band"
  }), React__default.createElement(Tooltip, {
    content: renderTooltip
  }), React__default.createElement(Bar, {
    layout: "vertical",
    stackId: "a",
    fill: acumulatedColor,
    dataKey: "acumulated",
    shape: renderAcumulatedShape,
    unit: unit
  }), React__default.createElement(Bar, {
    layout: "vertical",
    stackId: "a",
    fill: objectiveColor,
    dataKey: "objectiveDataPoint",
    shape: renderObjectiveShape,
    unit: unit
  })));
}

var getCustomNivoBarItem = function getCustomNivoBarItem(LabelComponent) {
  var injectedStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function CustomBarItem(barProps) {
    var _data$fill;

    var _barProps$bar = barProps.bar,
        data = _barProps$bar.data,
        bar = _objectWithoutProperties(_barProps$bar, ["data"]),
        borderRadius = barProps.borderRadius,
        borderWidth = barProps.borderWidth,
        label = barProps.label,
        shouldRenderLabel = barProps.shouldRenderLabel,
        isInteractive = barProps.isInteractive,
        onClick = barProps.onClick,
        onMouseEnter = barProps.onMouseEnter,
        onMouseLeave = barProps.onMouseLeave,
        tooltip = barProps.tooltip,
        isFocusable = barProps.isFocusable,
        ariaLabel = barProps.ariaLabel,
        ariaLabelledBy = barProps.ariaLabelledBy,
        ariaDescribedBy = barProps.ariaDescribedBy;

    var style = _objectSpread({}, barProps.style, {}, injectedStyle);

    var borderColor = style.borderColor,
        color2 = style.color,
        height = style.height,
        labelColor = style.labelColor,
        labelOpacity = style.labelOpacity,
        labelX = style.labelX,
        labelY = style.labelY,
        transform10 = style.transform,
        width = style.width;
    var theme = useTheme$1();

    var _useTooltip = useTooltip(),
        showTooltipFromEvent = _useTooltip.showTooltipFromEvent,
        showTooltipAt = _useTooltip.showTooltipAt,
        hideTooltip = _useTooltip.hideTooltip;

    var renderTooltip = useMemo( // eslint-disable-next-line react/display-name
    function () {
      return function () {
        return createElement(tooltip, _objectSpread({}, bar, {}, data));
      };
    }, [tooltip, bar, data]);
    var handleClick = useCallback(function (event) {
      onClick == null ? void 0 : onClick(_objectSpread({
        color: bar.color
      }, data), event);
    }, [bar, data, onClick]);
    var handleTooltip = useCallback(function (event) {
      return showTooltipFromEvent(renderTooltip(), event);
    }, [showTooltipFromEvent, renderTooltip]);
    var handleMouseEnter = useCallback(function (event) {
      onMouseEnter == null ? void 0 : onMouseEnter(data, event);
      showTooltipFromEvent(renderTooltip(), event);
    }, [data, onMouseEnter, showTooltipFromEvent, renderTooltip]);
    var handleMouseLeave = useCallback(function (event) {
      onMouseLeave == null ? void 0 : onMouseLeave(data, event);
      hideTooltip();
    }, [data, hideTooltip, onMouseLeave]);
    var handleFocus = useCallback(function () {
      showTooltipAt(renderTooltip(), [bar.absX + bar.width / 2, bar.absY]);
    }, [showTooltipAt, renderTooltip, bar]);
    var handleBlur = useCallback(function () {
      hideTooltip();
    }, [hideTooltip]);
    var widthProp = to(width, function (value) {
      return Math.max(value, 0);
    });
    var heightProp = to(height, function (value) {
      return Math.max(value, 0);
    });
    return React__default.createElement(animated.g, {
      transform: transform10
    }, style.showBarBackground && React__default.createElement("rect", {
      width: "100%",
      height: style.height.toString(),
      fill: Colors.gray[100],
      rx: borderRadius,
      ry: borderRadius
    }), React__default.createElement(animated.rect, {
      width: widthProp,
      height: heightProp,
      rx: borderRadius,
      ry: borderRadius,
      fill: (_data$fill = data.fill) !== null && _data$fill !== void 0 ? _data$fill : color2,
      strokeWidth: borderWidth,
      stroke: borderColor,
      focusable: isFocusable,
      tabIndex: isFocusable ? 0 : void 0,
      "aria-label": ariaLabel ? ariaLabel(data) : void 0,
      "aria-labelledby": ariaLabelledBy ? ariaLabelledBy(data) : void 0,
      "aria-describedby": ariaDescribedBy ? ariaDescribedBy(data) : void 0,
      onMouseEnter: isInteractive ? handleMouseEnter : void 0,
      onMouseMove: isInteractive ? handleTooltip : void 0,
      onMouseLeave: isInteractive ? handleMouseLeave : void 0,
      onClick: isInteractive ? handleClick : void 0,
      onFocus: isInteractive && isFocusable ? handleFocus : void 0,
      onBlur: isInteractive && isFocusable ? handleBlur : void 0
    }), shouldRenderLabel && React__default.createElement(animated.foreignObject, {
      width: style.showBarBackground ? "100%" : widthProp,
      height: heightProp,
      fillOpacity: labelOpacity,
      fill: labelColor,
      pointerEvents: "none"
    }, !LabelComponent && shouldRenderLabel && React__default.createElement(animated.text, {
      x: labelX,
      y: labelY,
      textAnchor: "middle",
      dominantBaseline: "central",
      fillOpacity: labelOpacity,
      style: _objectSpread({}, theme.labels.text, {
        pointerEvents: "none",
        fill: labelColor
      })
    }, label), LabelComponent && shouldRenderLabel && React__default.createElement(LabelComponent, _objectSpread({}, {
      label: label,
      defaultPosition: {
        x: labelX,
        y: labelY
      },
      defaultStyles: _objectSpread({}, theme.labels.text, {
        opacity: labelOpacity,
        backgroundColor: labelColor
      })
    }, {
      barProps: barProps,
      wrapperProps: {
        w: style.showBarBackground ? "100%" : void 0
      }
    }))));
  };
};

function portalRenderedLegendFactory(legendContainerSelector, Component, componentProps, getLayerDataFrom) {
  return function (props) {
    var _useState5 = useState(),
        _useState6 = _slicedToArray(_useState5, 2),
        containerEl = _useState6[0],
        setContainerEl = _useState6[1];

    var layerData;

    if (getLayerDataFrom) {
      layerData = props[getLayerDataFrom];
    }

    useLayoutEffect(function () {
      var el = document.querySelector(legendContainerSelector);

      if (el) {
        setContainerEl(el);
      }
    }, []);

    if (!containerEl) {
      return null;
    }

    return ReactDOM.createPortal(React__default.createElement(Component, _objectSpread({}, componentProps, {
      layerProps: props,
      layerData: layerData
    })), containerEl);
  };
}

var getPortalRenderedLegend = portalRenderedLegendFactory;
export { AcumBarChart, MultiLineAreaChart, PieChart, acumDataToChartData, clickKeyStateColors, clickKeyStateLabels, clickKeyStateToFullData, getCustomNivoBarItem, getPortalRenderedLegend, lineAreaDataToChartData, useAnimatableProperty };